import React, { useState, useEffect, useRef, useCallback } from 'react';
import { auth, db, functions } from './firebase';
import { 
  doc, onSnapshot, updateDoc, increment, collection, 
  addDoc, query, orderBy, setDoc, deleteDoc, 
  serverTimestamp, getDocs, runTransaction 
} from 'firebase/firestore';
import { formatarTempo, proximoTique } from './relogioPartida';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { enviarNotificacao } from "./notificacoesService";
import { AGORA_APP_ID } from './agora-config';
import { useSessaoAgora } from './useSessaoAgora';
import EstadoLigacaoEstadio from './EstadoLigacaoEstadio';
import { reproduzirVideoNoContentor } from './agoraSession';
import { construirMapaJogadores, uidAgoraDoUtilizador, contentorLocalDoUtilizador, contentorDeRemoto, limparContentorDeRemoto } from './mapaJogadores';
import PopupAtualizacaoEstadio from './PopupAtualizacaoEstadio';
import { shouldShowStadiumUpdate, markStadiumUpdateShown } from './stadiumUpdate';
import { adicionarXP } from './tabelaNiveis';
import { calcularNivel, obterImagemAdepto, obterImagemJogador } from './tabelaNiveis';

import imgFundoVideo from './assets/fundos/fundoVideo.webp';

// IMPORTAÇÃO DOS PRESENTES REAIS
// 1. IMPORTAÇÕES (Tudo em minúsculas como na tua pasta)
// ==========================================
// LISTA MESTRE DE PRESENTES PREMIUM (50 FUTEBOL)
// ==========================================

// Bloco Novos Presentes (Futebol)
// Bloco 1 (150 Moedas)
import imgGift90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import vidGift90Minutos from './assets/presentes/leves/gift_90_minutos.webm';

import imgGiftAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import vidGiftAnelCampeao from './assets/presentes/leves/gift_anel_de_campeao.webm';

import imgGiftApito from './assets/presentes/miniaturas/gift_apito.webp';
import vidGiftApito from './assets/presentes/leves/gift_apito.webm';

import imgGiftBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import vidGiftBaliza from './assets/presentes/leves/gift_baliza.webm';

import imgGiftBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';
import vidGiftBancadaVip from './assets/presentes/leves/gift_bancada_vip.webm';

import imgGiftBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import vidGiftBancoSuplentes from './assets/presentes/leves/gift_banco_de_suplentes.webm';

import imgGiftBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import vidGiftBandeiraClaque from './assets/presentes/leves/gift_bandeira_da_claque.webm';

import imgGiftBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import vidGiftBandeirolaCanto from './assets/presentes/leves/gift_bandeirola_de_canto.webm';

import imgGiftBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import vidGiftBolaOuro from './assets/presentes/leves/gift_bola_de_ouro.webm';

import imgGiftBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';
import vidGiftBolaChamas from './assets/presentes/leves/gift_bola_em_chamas.webm';

// Bloco Novos Presentes - Grupo 2 (Futebol)
import imgGiftBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import vidGiftBotaDiamante from './assets/presentes/leves/gift_bota_de_diamante.webm';

import imgGiftBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import vidGiftBrasao from './assets/presentes/leves/gift_brasao.webm';

import imgGiftCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import vidGiftCachecol from './assets/presentes/leves/gift_cachecol.webm';

import imgGiftCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import vidGiftCaneleiras from './assets/presentes/leves/gift_caneleiras.webm';

import imgGiftCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';
import vidGiftCanhaoCamisolas from './assets/presentes/leves/gift_canhao_de_camisolas.webm';

import imgGiftCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import vidGiftCanhaoConfetes from './assets/presentes/leves/gift_canhao_de_confetes.webm';

import imgGiftCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import vidGiftCapitao from './assets/presentes/leves/gift_capitao.webm';

import imgGiftCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import vidGiftCartaoAmarelo from './assets/presentes/leves/gift_cartao_amarelo.webm';

import imgGiftCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import vidGiftCartaoVermelho from './assets/presentes/leves/gift_cartao_vermelho.webm';

import imgGiftChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';
import vidGiftChapeuGuardaRedes from './assets/presentes/leves/gift_chapeu_de_guarda_redes.webm';

// Bloco Novos Presentes - Grupo 3 (Futebol)
import imgGiftChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import vidGiftChuteira from './assets/presentes/leves/gift_chuteira.webm';

import imgGiftChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import vidGiftChuteirasChamas from './assets/presentes/leves/gift_chuteiras_em_chamas.webm';

import imgGiftCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import vidGiftCronometro from './assets/presentes/leves/gift_cronometro.webm';

import imgGiftFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import vidGiftFiscalLinha from './assets/presentes/leves/gift_fiscal_de_linha.webm';

import imgGiftFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';
import vidGiftFitasClaque from './assets/presentes/leves/gift_fitas_da_claque.webm';

import imgGiftFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import vidGiftFumoClaque from './assets/presentes/leves/gift_fumo_da_claque.webm';

import imgGiftGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import vidGiftGorroAdepto from './assets/presentes/leves/gift_gorro_do_adepto.webm';

import imgGiftHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import vidGiftHallEntrada from './assets/presentes/leves/gift_hall_de_entrada.webm';

import imgGiftHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import vidGiftHatTrick from './assets/presentes/leves/gift_hat_trick.webm';

import imgGiftHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';
import vidGiftHolofotes from './assets/presentes/leves/gift_holofotes.webm';

// Bloco Novos Presentes - Grupo 4 (Futebol)
import imgGiftLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import vidGiftLuvaEspuma from './assets/presentes/leves/gift_luva_de_espuma.webm';

import imgGiftLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import vidGiftLuvaPlatina from './assets/presentes/leves/gift_luva_de_platina.webm';

import imgGiftLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import vidGiftLuvasGuardaRedes from './assets/presentes/leves/gift_luvas_de_guarda_redes.webm';

import imgGiftMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import vidGiftMedalhaCampeao from './assets/presentes/leves/gift_medalha_de_campeao.webm';

import imgGiftMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';
import vidGiftMedalhaViceCampeao from './assets/presentes/leves/gift_medalha_de_vice_campeao.webm';

import imgGiftMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import vidGiftMegafone from './assets/presentes/leves/gift_megafone.webm';

import imgGiftMeias from './assets/presentes/miniaturas/gift_meias.webp';
import vidGiftMeias from './assets/presentes/leves/gift_meias.webm';

import imgGiftMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import vidGiftMelhorTreinador from './assets/presentes/leves/gift_melhor_treinador.webm';

import imgGiftMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import vidGiftMoedaAoAr from './assets/presentes/leves/gift_moeda_ao_ar.webm';

import imgGiftPlacard from './assets/presentes/miniaturas/gift_placard.webp';
import vidGiftPlacard from './assets/presentes/leves/gift_placard.webm';

// Bloco Novos Presentes - Grupo 5 (Futebol - Final)
import imgGiftRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import vidGiftRelvado from './assets/presentes/leves/gift_relvado.webm';

import imgGiftSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import vidGiftSprayBarreira from './assets/presentes/leves/gift_spray_de_barreira.webm';

import imgGiftSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import vidGiftSubstituicao from './assets/presentes/leves/gift_substituicao.webm';

import imgGiftTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import vidGiftTacaSuprema from './assets/presentes/leves/gift_taca_suprema.webm';

import imgGiftTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';
import vidGiftTamborClaque from './assets/presentes/leves/gift_tambor_da_claque.webm';

import imgGiftTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import vidGiftTorresEstadio from './assets/presentes/leves/gift_torres_do_estadio.webm';

import imgGiftTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import vidGiftTrofeuCampeao from './assets/presentes/leves/gift_trofeu_de_campeao.webm';

import imgGiftTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import vidGiftTrofeuGuardaRedes from './assets/presentes/leves/gift_trofeu_de_guarda_redes.webm';

import imgGiftVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import vidGiftVitoria from './assets/presentes/leves/gift_vitoria.webm';

import imgGiftVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';
import vidGiftVuvuzela from './assets/presentes/leves/gift_vuvuzela.webm';

// =========================================================================
// IMPORTS DOS STICKERS (Aproveitando as miniaturas dos presentes de futebol)
// =========================================================================

// Grupo 1
import imgSticker90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import imgStickerAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import imgStickerApito from './assets/presentes/miniaturas/gift_apito.webp';
import imgStickerBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import imgStickerBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';

// Grupo 2
import imgStickerBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import imgStickerBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import imgStickerBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import imgStickerBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import imgStickerBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';

// Grupo 3
import imgStickerBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import imgStickerBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import imgStickerCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import imgStickerCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import imgStickerCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';

// Grupo 4
import imgStickerCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import imgStickerCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import imgStickerCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import imgStickerCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import imgStickerChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';

// Grupo 5
import imgStickerChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import imgStickerChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import imgStickerCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import imgStickerFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import imgStickerFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';

// Grupo 6
import imgStickerFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import imgStickerGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import imgStickerHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import imgStickerHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import imgStickerHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';

// Grupo 7
import imgStickerLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import imgStickerLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import imgStickerLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import imgStickerMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import imgStickerMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';

// Grupo 8
import imgStickerMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import imgStickerMeias from './assets/presentes/miniaturas/gift_meias.webp';
import imgStickerMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import imgStickerMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import imgStickerPlacard from './assets/presentes/miniaturas/gift_placard.webp';

// Grupo 9
import imgStickerRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import imgStickerSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import imgStickerSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import imgStickerTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import imgStickerTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';

// Grupo 10
import imgStickerTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import imgStickerTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import imgStickerTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import imgStickerVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import imgStickerVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';

import PresenteTransparente from './PresenteTransparente';
import { videoSemFundo } from './presentesSemFundo';
import { useAquecerPresentes } from './useAquecerPresentes';

const LISTA_PRESENTES = [
  // ==========================================
  // BLOCO 1: 150 MOEDAS
  // ==========================================
  { id: 1, nome: '90 Minutos', preco: 150, icone: imgGift90Minutos, video: vidGift90Minutos },
  { id: 2, nome: 'Anel de Campeão', preco: 150, icone: imgGiftAnelCampeao, video: vidGiftAnelCampeao },
  { id: 3, nome: 'Apito', preco: 150, icone: imgGiftApito, video: vidGiftApito },
  { id: 4, nome: 'Baliza', preco: 150, icone: imgGiftBaliza, video: vidGiftBaliza },
  { id: 5, nome: 'Bancada VIP', preco: 150, icone: imgGiftBancadaVip, video: vidGiftBancadaVip },

  // ==========================================
  // BLOCO 2: 300 MOEDAS
  // ==========================================
  { id: 6, nome: 'Banco de Suplentes', preco: 300, icone: imgGiftBancoSuplentes, video: vidGiftBancoSuplentes },
  { id: 7, nome: 'Bandeira da Claque', preco: 300, icone: imgGiftBandeiraClaque, video: vidGiftBandeiraClaque },
  { id: 8, nome: 'Bandeirola de Canto', preco: 300, icone: imgGiftBandeirolaCanto, video: vidGiftBandeirolaCanto },
  { id: 9, nome: 'Bola de Ouro', preco: 300, icone: imgGiftBolaOuro, video: vidGiftBolaOuro },
  { id: 10, nome: 'Bola em Chamas', preco: 300, icone: imgGiftBolaChamas, video: vidGiftBolaChamas },

  // ==========================================
  // BLOCO 3: 450 MOEDAS
  // ==========================================
  { id: 11, nome: 'Bota de Diamante', preco: 450, icone: imgGiftBotaDiamante, video: vidGiftBotaDiamante },
  { id: 12, nome: 'Brasão', preco: 450, icone: imgGiftBrasao, video: vidGiftBrasao },
  { id: 13, nome: 'Cachecol', preco: 450, icone: imgGiftCachecol, video: vidGiftCachecol },
  { id: 14, nome: 'Caneleiras', preco: 450, icone: imgGiftCaneleiras, video: vidGiftCaneleiras },
  { id: 15, nome: 'Canhão de Camisolas', preco: 450, icone: imgGiftCanhaoCamisolas, video: vidGiftCanhaoCamisolas },

  // ==========================================
  // BLOCO 4: 600 MOEDAS
  // ==========================================
  { id: 16, nome: 'Canhão de Confetes', preco: 600, icone: imgGiftCanhaoConfetes, video: vidGiftCanhaoConfetes },
  { id: 17, nome: 'Capitão', preco: 600, icone: imgGiftCapitao, video: vidGiftCapitao },
  { id: 18, nome: 'Cartão Amarelo', preco: 600, icone: imgGiftCartaoAmarelo, video: vidGiftCartaoAmarelo },
  { id: 19, nome: 'Cartão Vermelho', preco: 600, icone: imgGiftCartaoVermelho, video: vidGiftCartaoVermelho },
  { id: 20, nome: 'Chapéu de Guarda-Redes', preco: 600, icone: imgGiftChapeuGuardaRedes, video: vidGiftChapeuGuardaRedes },

  // ==========================================
  // BLOCO 5: 750 MOEDAS
  // ==========================================
  { id: 21, nome: 'Chuteira', preco: 750, icone: imgGiftChuteira, video: vidGiftChuteira },
  { id: 22, nome: 'Chuteiras em Chamas', preco: 750, icone: imgGiftChuteirasChamas, video: vidGiftChuteirasChamas },
  { id: 23, nome: 'Cronómetro', preco: 750, icone: imgGiftCronometro, video: vidGiftCronometro },
  { id: 24, nome: 'Fiscal de Linha', preco: 750, icone: imgGiftFiscalLinha, video: vidGiftFiscalLinha },
  { id: 25, nome: 'Fitas da Claque', preco: 750, icone: imgGiftFitasClaque, video: vidGiftFitasClaque },

  // ==========================================
  // BLOCO 6: 900 MOEDAS
  // ==========================================
  { id: 26, nome: 'Fumo da Claque', preco: 900, icone: imgGiftFumoClaque, video: vidGiftFumoClaque },
  { id: 27, nome: 'Gorro do Adepto', preco: 900, icone: imgGiftGorroAdepto, video: vidGiftGorroAdepto },
  { id: 28, nome: 'Hall de Entrada', preco: 900, icone: imgGiftHallEntrada, video: vidGiftHallEntrada },
  { id: 29, nome: 'Hat-Trick', preco: 900, icone: imgGiftHatTrick, video: vidGiftHatTrick },
  { id: 30, nome: 'Holofotes', preco: 900, icone: imgGiftHolofotes, video: vidGiftHolofotes },

  // ==========================================
  // BLOCO 7: 1050 MOEDAS
  // ==========================================
  { id: 31, nome: 'Luva de Espuma', preco: 1050, icone: imgGiftLuvaEspuma, video: vidGiftLuvaEspuma },
  { id: 32, nome: 'Luva de Platina', preco: 1050, icone: imgGiftLuvaPlatina, video: vidGiftLuvaPlatina },
  { id: 33, nome: 'Luvas de Guarda-Redes', preco: 1050, icone: imgGiftLuvasGuardaRedes, video: vidGiftLuvasGuardaRedes },
  { id: 34, nome: 'Medalha de Campeão', preco: 1050, icone: imgGiftMedalhaCampeao, video: vidGiftMedalhaCampeao },
  { id: 35, nome: 'Medalha de Vice-Campeão', preco: 1050, icone: imgGiftMedalhaViceCampeao, video: vidGiftMedalhaViceCampeao },

  // ==========================================
  // BLOCO 8: 1200 MOEDAS
  // ==========================================
  { id: 36, nome: 'Megafone', preco: 1200, icone: imgGiftMegafone, video: vidGiftMegafone },
  { id: 37, nome: 'Meias', preco: 1200, icone: imgGiftMeias, video: vidGiftMeias },
  { id: 38, nome: 'Melhor Treinador', preco: 1200, icone: imgGiftMelhorTreinador, video: vidGiftMelhorTreinador },
  { id: 39, nome: 'Moeda ao Ar', preco: 1200, icone: imgGiftMoedaAoAr, video: vidGiftMoedaAoAr },
  { id: 40, nome: 'Placard', preco: 1200, icone: imgGiftPlacard, video: vidGiftPlacard },

  // ==========================================
  // BLOCO 9: 1350 MOEDAS
  // ==========================================
  { id: 41, nome: 'Relvado', preco: 1350, icone: imgGiftRelvado, video: vidGiftRelvado },
  { id: 42, nome: 'Spray de Barreira', preco: 1350, icone: imgGiftSprayBarreira, video: vidGiftSprayBarreira },
  { id: 43, nome: 'Substituição', preco: 1350, icone: imgGiftSubstituicao, video: vidGiftSubstituicao },
  { id: 44, nome: 'Taça Suprema', preco: 1350, icone: imgGiftTacaSuprema, video: vidGiftTacaSuprema },
  { id: 45, nome: 'Tambor da Claque', preco: 1350, icone: imgGiftTamborClaque, video: vidGiftTamborClaque },

  // ==========================================
  // BLOCO 10: 1500 MOEDAS
  // ==========================================
  { id: 46, nome: 'Torres do Estádio', preco: 1500, icone: imgGiftTorresEstadio, video: vidGiftTorresEstadio },
  { id: 47, nome: 'Troféu de Campeão', preco: 1500, icone: imgGiftTrofeuCampeao, video: vidGiftTrofeuCampeao },
  { id: 48, nome: 'Troféu de Guarda-Redes', preco: 1500, icone: imgGiftTrofeuGuardaRedes, video: vidGiftTrofeuGuardaRedes },
  { id: 49, nome: 'Vitória', preco: 1500, icone: imgGiftVitoria, video: vidGiftVitoria },
  { id: 50, nome: 'Vuvuzela', preco: 1500, icone: imgGiftVuvuzela, video: vidGiftVuvuzela }
];

  const LISTA_STICKERS = [
    // Patamar 100 Moedas
    { id: 101, nome: '90 Minutos', preco: 100, icone: imgSticker90Minutos, video: "" },
    { id: 102, nome: 'Anel de Campeão', preco: 100, icone: imgStickerAnelCampeao, video: "" },
    { id: 103, nome: 'Apito', preco: 100, icone: imgStickerApito, video: "" },
    { id: 104, nome: 'Baliza', preco: 100, icone: imgStickerBaliza, video: "" },
    { id: 105, nome: 'Bancada VIP', preco: 100, icone: imgStickerBancadaVip, video: "" },
    { id: 106, nome: 'Banco de Suplentes', preco: 100, icone: imgStickerBancoSuplentes, video: "" },
    { id: 107, nome: 'Bandeira da Claque', preco: 100, icone: imgStickerBandeiraClaque, video: "" },
    { id: 108, nome: 'Bandeirola de Canto', preco: 100, icone: imgStickerBandeirolaCanto, video: "" },
    { id: 109, nome: 'Bola de Ouro', preco: 100, icone: imgStickerBolaOuro, video: "" },
    { id: 110, nome: 'Bola em Chamas', preco: 100, icone: imgStickerBolaChamas, video: "" },
  
    // Patamar 150 Moedas
    { id: 111, nome: 'Bota de Diamante', preco: 150, icone: imgStickerBotaDiamante, video: "" },
    { id: 112, nome: 'Brasão', preco: 150, icone: imgStickerBrasao, video: "" },
    { id: 113, nome: 'Cachecol', preco: 150, icone: imgStickerCachecol, video: "" },
    { id: 114, nome: 'Caneleiras', preco: 150, icone: imgStickerCaneleiras, video: "" },
    { id: 115, nome: 'Canhão de Camisolas', preco: 150, icone: imgStickerCanhaoCamisolas, video: "" },
    { id: 116, nome: 'Canhão de Confetes', preco: 150, icone: imgStickerCanhaoConfetes, video: "" },
    { id: 117, nome: 'Capitão', preco: 150, icone: imgStickerCapitao, video: "" },
    { id: 118, nome: 'Cartão Amarelo', preco: 150, icone: imgStickerCartaoAmarelo, video: "" },
    { id: 119, nome: 'Cartão Vermelho', preco: 150, icone: imgStickerCartaoVermelho, video: "" },
    { id: 120, nome: 'Chapéu de Guarda-Redes', preco: 150, icone: imgStickerChapeuGuardaRedes, video: "" },
  
    // Patamar 250 Moedas
    { id: 121, nome: 'Chuteira', preco: 250, icone: imgStickerChuteira, video: "" },
    { id: 122, nome: 'Chuteiras em Chamas', preco: 250, icone: imgStickerChuteirasChamas, video: "" },
    { id: 123, nome: 'Cronómetro', preco: 250, icone: imgStickerCronometro, video: "" },
    { id: 124, nome: 'Fiscal de Linha', preco: 250, icone: imgStickerFiscalLinha, video: "" },
    { id: 125, nome: 'Fitas da Claque', preco: 250, icone: imgStickerFitasClaque, video: "" },
    { id: 126, nome: 'Fumo da Claque', preco: 250, icone: imgStickerFumoClaque, video: "" },
    { id: 127, nome: 'Gorro do Adepto', preco: 250, icone: imgStickerGorroAdepto, video: "" },
    { id: 128, nome: 'Hall de Entrada', preco: 250, icone: imgStickerHallEntrada, video: "" },
    { id: 129, nome: 'Hat-Trick', preco: 250, icone: imgStickerHatTrick, video: "" },
    { id: 130, nome: 'Holofotes', preco: 250, icone: imgStickerHolofotes, video: "" },
  
    // Patamar 400 Moedas
    { id: 131, nome: 'Luva de Espuma', preco: 400, icone: imgStickerLuvaEspuma, video: "" },
    { id: 132, nome: 'Luva de Platina', preco: 400, icone: imgStickerLuvaPlatina, video: "" },
    { id: 133, nome: 'Luvas de Guarda-Redes', preco: 400, icone: imgStickerLuvasGuardaRedes, video: "" },
    { id: 134, nome: 'Medalha de Campeão', preco: 400, icone: imgStickerMedalhaCampeao, video: "" },
    { id: 135, nome: 'Medalha de Vice-Campeão', preco: 400, icone: imgStickerMedalhaViceCampeao, video: "" },
    { id: 136, nome: 'Megafone', preco: 400, icone: imgStickerMegafone, video: "" },
    { id: 137, nome: 'Meias', preco: 400, icone: imgStickerMeias, video: "" },
    { id: 138, nome: 'Melhor Treinador', preco: 400, icone: imgStickerMelhorTreinador, video: "" },
    { id: 139, nome: 'Moeda ao Ar', preco: 400, icone: imgStickerMoedaAoAr, video: "" },
    { id: 140, nome: 'Placard', preco: 400, icone: imgStickerPlacard, video: "" },
  
    // Patamar 600 Moedas
    { id: 141, nome: 'Relvado', preco: 600, icone: imgStickerRelvado, video: "" },
    { id: 142, nome: 'Spray de Barreira', preco: 600, icone: imgStickerSprayBarreira, video: "" },
    { id: 143, nome: 'Substituição', preco: 600, icone: imgStickerSubstituicao, video: "" },
    { id: 144, nome: 'Taça Suprema', preco: 600, icone: imgStickerTacaSuprema, video: "" },
    { id: 145, nome: 'Tambor da Claque', preco: 600, icone: imgStickerTamborClaque, video: "" },
    { id: 146, nome: 'Torres do Estádio', preco: 600, icone: imgStickerTorresEstadio, video: "" },
    { id: 147, nome: 'Troféu de Campeão', preco: 600, icone: imgStickerTrofeuCampeao, video: "" },
    { id: 148, nome: 'Troféu de Guarda-Redes', preco: 600, icone: imgStickerTrofeuGuardaRedes, video: "" },
    { id: 149, nome: 'Vitória', preco: 600, icone: imgStickerVitoria, video: "" },
    { id: 150, nome: 'Vuvuzela', preco: 600, icone: imgStickerVuvuzela, video: "" }
  ];

 // ⚡ ARRAY RETIFICADO: 50 LUCKYS COM NOMES 100% EXATOS E FIÉIS AOS ASSETS
const LISTA_LUCKYS = [
  // Nível 1: Equipamentos e Pequenos Acessórios (1 a 25 Bolas)
  { id: 501, nome: 'Apito', preco: 1, icone: new URL('./assets/presentes/miniaturas/lucky_apito.webp', import.meta.url).href, tipo: 'lucky', selo: 'jackpot_1000x' },
  { id: 502, nome: 'Meias', preco: 2, icone: new URL('./assets/presentes/miniaturas/lucky_meias.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 503, nome: 'Caneleiras', preco: 5, icone: new URL('./assets/presentes/miniaturas/lucky_caneleiras.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 504, nome: 'Capitão', preco: 10, icone: new URL('./assets/presentes/miniaturas/lucky_capitao.webp', import.meta.url).href, tipo: 'lucky', selo: 'jackpot_1000x' },
  { id: 505, nome: 'Cronómetro', preco: 10, icone: new URL('./assets/presentes/miniaturas/lucky_cronometro.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 506, nome: '90 Minutos', preco: 12, icone: new URL('./assets/presentes/miniaturas/lucky_90_minutos.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 507, nome: 'Bota de Diamante', preco: 15, icone: new URL('./assets/presentes/miniaturas/lucky_bota_de_diamante.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 508, nome: 'Chapéu de Guarda-Redes', preco: 20, icone: new URL('./assets/presentes/miniaturas/lucky_chapeu_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 509, nome: 'Luvas de Guarda-Redes', preco: 22, icone: new URL('./assets/presentes/miniaturas/lucky_luvas_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 510, nome: 'Chuteira', preco: 25, icone: new URL('./assets/presentes/miniaturas/lucky_chuteira.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 2: Campo, Estruturas e Arbitragem (30 a 90 Bolas)
  { id: 511, nome: 'Cartão Amarelo', preco: 30, icone: new URL('./assets/presentes/miniaturas/lucky_cartao_amarelo.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 512, nome: 'Cartão Vermelho', preco: 35, icone: new URL('./assets/presentes/miniaturas/lucky_cartao_vermelho.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 513, nome: 'Spray de Barreira', preco: 40, icone: new URL('./assets/presentes/miniaturas/lucky_spray_de_barreira.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 514, nome: 'Bandeirola de Canto', preco: 50, icone: new URL('./assets/presentes/miniaturas/lucky_bandeirola_de_canto.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 515, nome: 'Fiscal de Linha', preco: 55, icone: new URL('./assets/presentes/miniaturas/lucky_fiscal_de_linha.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 516, nome: 'Baliza', preco: 60, icone: new URL('./assets/presentes/miniaturas/lucky_baliza.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 517, nome: 'Relvado', preco: 70, icone: new URL('./assets/presentes/miniaturas/lucky_relvado.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 518, nome: 'Banco de Suplentes', preco: 75, icone: new URL('./assets/presentes/miniaturas/lucky_banco_de_suplentes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 519, nome: 'Substituição', preco: 80, icone: new URL('./assets/presentes/miniaturas/lucky_substituicao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 520, nome: 'Hall de Entrada', preco: 90, icone: new URL('./assets/presentes/miniaturas/lucky_hall_de_entrada.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 3: Festa, Claques e Bancadas (100 a 200 Bolas)
  { id: 521, nome: 'Bancada VIP', preco: 100, icone: new URL('./assets/presentes/miniaturas/lucky_bancada_vip.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 522, nome: 'Torres do Estádio', preco: 110, icone: new URL('./assets/presentes/miniaturas/lucky_torres_do_estadio.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 523, nome: 'Placard', preco: 120, icone: new URL('./assets/presentes/miniaturas/lucky_placard.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 524, nome: 'Holofotes', preco: 130, icone: new URL('./assets/presentes/miniaturas/lucky_holofotes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 525, nome: 'Gorro de Adepto', preco: 140, icone: new URL('./assets/presentes/miniaturas/lucky_gorro_do_adepto.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 526, nome: 'Vuvuzela', preco: 150, icone: new URL('./assets/presentes/miniaturas/lucky_vuvuzela.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 527, nome: 'Moeda ao Ar', preco: 160, icone: new URL('./assets/presentes/miniaturas/lucky_moeda_ao_ar.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 528, nome: 'Luva de Espuma', preco: 170, icone: new URL('./assets/presentes/miniaturas/lucky_luva_de_espuma.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 529, nome: 'Cachecol', preco: 185, icone: new URL('./assets/presentes/miniaturas/lucky_cachecol.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 530, nome: 'Bandeira da Claque', preco: 200, icone: new URL('./assets/presentes/miniaturas/lucky_bandeira_da_claque.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 4: Mega Efeitos e Adrenalina em Campo (210 a 350 Bolas)
  { id: 531, nome: 'Fitas da Claque', preco: 210, icone: new URL('./assets/presentes/miniaturas/lucky_fitas_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 532, nome: 'Fumo da Claque', preco: 220, icone: new URL('./assets/presentes/miniaturas/lucky_fumo_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 533, nome: 'Megafone', preco: 240, icone: new URL('./assets/presentes/miniaturas/lucky_megafone.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 534, nome: 'Canhão de Camisolas', preco: 260, icone: new URL('./assets/presentes/miniaturas/lucky_canhao_de_camisolas.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 535, nome: 'Canhão de Confetes', preco: 280, icone: new URL('./assets/presentes/miniaturas/lucky_canhao_de_confetes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 536, nome: 'Tambor da Claque', preco: 300, icone: new URL('./assets/presentes/miniaturas/lucky_tambor_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 537, nome: 'Chuteiras em Chamas', preco: 320, icone: new URL('./assets/presentes/miniaturas/lucky_chuteiras_em_chamas.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 538, nome: 'Bola em Chamas', preco: 350, icone: new URL('./assets/presentes/miniaturas/lucky_bola_em_chamas.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 5: Galeria de Troféus Supremos (380 a 500 Bolas)
  { id: 539, nome: 'Hat-Trick', preco: 380, icone: new URL('./assets/presentes/miniaturas/lucky_hat_trick.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 540, nome: 'Medalha de Vice Campeão', preco: 400, icone: new URL('./assets/presentes/miniaturas/lucky_medalha_de_vice_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 541, nome: 'Medalha de Campeão', preco: 410, icone: new URL('./assets/presentes/miniaturas/lucky_medalha_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 542, nome: 'Melhor Treinador', preco: 420, icone: new URL('./assets/presentes/miniaturas/lucky_melhor_treinador.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 543, nome: 'Troféu de Campeão', preco: 430, icone: new URL('./assets/presentes/miniaturas/lucky_trofeu_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 544, nome: 'Troféu de Guarda-Redes', preco: 440, icone: new URL('./assets/presentes/miniaturas/lucky_trofeu_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 545, nome: 'Luva de Platina', preco: 450, icone: new URL('./assets/presentes/miniaturas/lucky_luva_de_platina.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 546, nome: 'Brasão', preco: 460, icone: new URL('./assets/presentes/miniaturas/lucky_brasao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 547, nome: 'Anel de Campeão', preco: 470, icone: new URL('./assets/presentes/miniaturas/lucky_anel_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 548, nome: 'Bola de Ouro', preco: 480, icone: new URL('./assets/presentes/miniaturas/lucky_bola_de_ouro.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 549, nome: 'Vitória', preco: 490, icone: new URL('./assets/presentes/miniaturas/lucky_vitoria.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 550, nome: 'Taça Suprema', preco: 500, icone: new URL('./assets/presentes/miniaturas/lucky_taca_suprema.webp', import.meta.url).href, tipo: 'lucky' }
];

/**
 * ⚡ MOTOR INTELIGENTE DE MULTIPLICADORES LUCKYS (PROTECÇÃO BANCÁRIA - MARGEM 25%)
 * Garante que a PWA nunca fica com prejuízo. Prémios pagos pelo próprio fundo acumulado!
 */
const calcularResultadoLucky = (presenteLucky, fundoReservaDisponivel = 0) => {
  const precoItem = presenteLucky.preco || presenteLucky.custo || 0;
  const semente = Math.floor(Math.random() * 100000) + 1; // Base 100.000 para ler decimais finos
  let multiplicador = 0;

  // LÓGICA 1: CAÇA-JACKPOT 1000X (Exclusivo para o Apito e Capitão)
  if (presenteLucky.selo === 'jackpot_1000x') {
    // 0.096% de probabilidade de dar 1000X -> 96 sementes em 100.000
    if (semente <= 96) {
      multiplicador = 1000; // O JACKPOT SUPREMO!
    } else {
      multiplicador = 0; // 99.904% de probabilidade de PERDER TUDO
    }
  } 
  // LÓGICA 2: RECOMPENSAS REGULARES (Restantes presentes normais das Luckys)
  else {
    // Probabilidades Oficiais Ajustadas do Relatório Mestre
    if (semente <= 60890) {
      multiplicador = 0;   // Perder (0x) -> 60.89%
    } else if (semente <= 82890) {
      multiplicador = 1;   // Retorno (1x) -> 22.00%
    } else if (semente <= 94390) {
      multiplicador = 2;   // Dobro (2x) -> 11.50%
    } else if (semente <= 97390) {
      multiplicador = 5;   // 5x -> 3.00%
    } else if (semente <= 99390) {
      multiplicador = 10;  // 10x -> 2.00%
    } else if (semente <= 99890) {
      multiplicador = 20;  // 20x -> 0.50%
    } else if (semente <= 99990) {
      multiplicador = 50;  // 50x -> 0.10%
    } else {
      multiplicador = 100; // 100x -> 0.01%
    }
  }

  const custoPremioBolas = precoItem * multiplicador;

  // Proteção Bancária: Se o prémio ultrapassar o cofre disponível, força a devolução (1x) ou perda (0x)
  if (multiplicador > 1 && custoPremioBolas > fundoReservaDisponivel) {
    multiplicador = fundoReservaDisponivel >= precoItem ? 1 : 0;
  }

  return {
    multiplicador,
    premioFinalBolas: precoItem * multiplicador,
    ganhou: multiplicador > 0
  };
};

function JogoPK({ idBatalha, idA, espectador = false, aoSair }) {
    // Põe os vídeos dos presentes a descarregar já, para o primeiro presente não chegar atrasado.
    useAquecerPresentes();
  const messagesEndRef = useRef(null);
      const scrollToBottom = () => {
    setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: 'auto', block: 'end' });
      }
    }, 200);
  };

  const [idsStickersDoadosAlvo, setIdsStickersDoadosAlvo] = useState([]);
  const [batalha, setBatalha] = useState(null);
  const [microLigado, setMicroLigado] = useState(true);
  const [mostrarListaEspectadores, setMostrarListaEspectadores] = useState(false);
  const [mostrarBuscaRivalRapida, setMostrarBuscaRivalRapida] = useState(false);
  const [listaEspectadores, setListaEspectadores] = useState([]);
  const [mensagemJuiz, setMensagemJuiz] = useState("");
  const [videoAtivo, setVideoAtivo] = useState(null);
  const [mensagensChat, setMensagensChat] = useState([]);
  const [textoMensagem, setTextoMensagem] = useState("");
  const [mostrarResultadoFinal, setMostrarResultadoFinal] = useState(false);
  const [mostrarOpcoesFim, setMostrarOpcoesFim] = useState(false);
  const [pesquisaArena, setPesquisaArena] = useState("");
  const [totalTapTapsArena, setTotalTapTapsArena] = useState(0);
    // Estados de pertença à Claque Oficial Alfa
  const [euPertencoAClaqueA, setEuPertencoAClaqueA] = useState(false);
  const [euPertencoAClaqueB, setEuPertencoAClaqueB] = useState(false);
    // Contadores e metas de cliques para as duas claques independentes
  const [tapsClaqueA, setTapsClaqueA] = useState(0);
  const [tapsClaqueB, setTapsClaqueB] = useState(0);
  const [metaClaqueAAtingida, setMetaClaqueAAtingida] = useState(false);
  const [metaClaqueBAtingida, setMetaClaqueBAtingida] = useState(false);
    // Contadores de membros totais e vitalícios de cada claque
  const [totalMembrosClaqueA, setTotalMembrosClaqueA] = useState(0);
  const [totalMembrosClaqueB, setTotalMembrosClaqueB] = useState(0);
    const [idsClaqueA, setIdsClaqueA] = useState([]);
  const [idsClaqueB, setIdsClaqueB] = useState([]);

    // Estados para as Caixas Fortes Dinâmicas de cada Streamer na Arena
  const [moedasStreamerA, setMoedasStreamerA] = useState(0);
  const [moedasStreamerB, setMoedasStreamerB] = useState(0);

  const [mostrarPresentesPK, setMostrarPresentesPK] = useState(false);
  const [alvoPresentePK, setAlvoPresentePK] = useState('A');
  const [alvoStickerPK, setAlvoStickerPK] = useState('A');
  const [stickerAtivo, setStickerAtivo] = useState(null);

  const wakeLockRef = useRef(null);

    // ⚡ GATILHOS EXCLUSIVOS PARA O MENU DE LUCKYS NA ARENA PK
  const [mostrarMenuLuckys, setMostrarMenuLuckys] = useState(false);
  const [mostrarMenuPresentesNormais, setMostrarMenuPresentesNormais] = useState(false);
  const [mostrarMenuStickers, setMostrarMenuStickers] = useState(false);
  const [tipoMenuAtivo, setTipoMenuAtivo] = useState(""); 
  const [utilizadorAlvoId, setUtilizadorAlvoId] = useState(null);
  const [quantidadeSelecionada, setQuantidadeSelecionada] = useState(1);
  const [ultimoLuckyEnviado, setUltimoLuckyEnviado] = useState(null);
  const [alvoUltimoLucky, setAlvoUltimoLucky] = useState(null);
  const [caixaForteBolas, setCaixaForteBolas] = useState(0); 
  const [avisoPresente, setAvisoPresente] = useState(null);
  const [animacoesAtivas, setAnimacoesAtivas] = useState([]);
  const [listaAvisosFeed, setListaAvisosFeed] = useState([]);
  const [comboPresenteAtivo, setComboPresenteAtivo] = useState(null);
  const [comboDestinatarioAtivo, setComboDestinatarioAtivo] = useState(null);
  const [contagemComboCliques, setContagemComboCliques] = useState(0);
  const [mostrarBolinhaRosa, setMostrarBolinhaRosa] = useState(false);
  const [presenteSelecionado, setPresenteSelecionado] = useState(null);

    const [mostrarCadernetaDono, setMostrarCadernetaDono] = useState(false); // 🍀 NOVO: Controla o Álbum Pessoal do Anfitrião
  const [cromosDesbloqueadosIds, setCromosDesbloqueadosIds] = useState([]);
  const [uidVencedorNeonAtivo, setUidVencedorNeonAtivo] = useState(null); // 🟢 NOVO: Controla o flash verde néon no ecrã

      // ===========================================================================
  // 🟢 ESCUTA EM TEMPO REAL DA CADERNETA CORRETA (TRACADO POR UTILIZADOR)
  // ===========================================================================
  useEffect(() => {
    if (!batalha) return;

    const meuUidLogado = auth.currentUser?.uid;
    const euSouLutador = meuUidLogado === batalha.idA || meuUidLogado === batalha.idB;

    let idStreamerAlvo;

    if (euSouLutador) {
      // Se for um dos streamers, escuta estritamente a SUA própria caderneta
      idStreamerAlvo = meuUidLogado;
    } else {
      // Se for espetador, segue o botão reativo do alvo selecionado (Lado A ou B)
      idStreamerAlvo = alvoStickerPK === 'B' ? batalha.idB : batalha.idA;
    }

    if (!idStreamerAlvo) return;

    // Cria o ouvinte isolado para o ID determinado
    const desprotegerCaderneta = onSnapshot(
      collection(db, "utilizadores", idStreamerAlvo, "caderneta_stickers"),
      (snapshot) => {
        const obtidos = [];
        snapshot.forEach((doc) => {
          if (doc.data().desbloqueado === true) {
            obtidos.push(String(doc.data().id));
          }
        });
        
        setIdsStickersDoadosAlvo(obtidos);
        setCromosDesbloqueadosIds(obtidos);
      },
      (err) => console.error("Erro na caderneta ativa da Arena:", err)
    );

    return () => {
      desprotegerCaderneta();
    };
  }, [batalha, alvoStickerPK]);
  
      // =========================================================================
  // 🎡 ANTENA EM TEMPO REAL: ESCUTADOR REATIVO DE LUCKYS E PRESENTES NA ARENA PK
  // =========================================================================
  const removerAnimacao = useCallback((chave) => {
    setAnimacoesAtivas((atuais) => atuais.filter((a) => a.chave !== chave));
  }, []);

  useEffect(() => {
    if (!idBatalha) return;

    // Dentro do useEffect da Antena, muda isto:
const animRef = collection(db, "batalhasAtivas", idBatalha, "animacoes_presentes");
    const jaMostrados = new Set();
    const cronometrosDeCartao = new Set();

    const unsubAnim = onSnapshot(animRef, (snap) => {
      snap.docChanges().forEach((mudanca) => {
        if (mudanca.type !== "added") return;

        const idDoc = mudanca.doc.id;
        if (jaMostrados.has(idDoc)) return;
        jaMostrados.add(idDoc);

        const dados = mudanca.doc.data() || {};
        const carimboMs = dados.criadoEm?.toMillis?.() ?? null;
        if (carimboMs !== null && Date.now() - carimboMs > 90000) return;

        const media = dados.videoUrl || dados.iconeUrl || "";
        const ehLucky = !!dados.isLucky;
        const tipoItem = dados.tipo || "";

        // ------------------------------------------------ ANIMAÇÃO NO ECRÃ
        // Luckys não desenham animação central (apenas cartão VIP), mas Vídeos e Stickers sim!
        if (media && !ehLucky) {
          // Força a deteção correta se é vídeo (.mp4, .webm, .mov) ou se o motor carimbou como 'mp4'
          const ehVideo = tipoItem === 'mp4' || /\.(mp4|webm|mov)(\?|#|\$)/i.test(media);
          
          const entrada = {
            chave: dados.chave || `${idDoc}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
            media,
            ehVideo,
            poster: dados.posterUrl || dados.iconeUrl || "",
          };
          
          // Injeta na fila reativa (limite de 3 para performance)
          setAnimacoesAtivas((atuais) => [...atuais, entrada].slice(-3));
        }

        // ----------------------------------------------------- CARTÃO VIP
        const uidRemetente = dados.deUid || dados.uid || idDoc;

        // 🎯 Correção Crítica 4.1: Sincronização direta com a base de dados eliminando o desfasamento do combo
        const dadosCombo = {
          id: dados.id || idDoc,
          uidRemetente,
          fotoRemetente: dados.deFoto || "",
          nomeRemetente: dados.deNome || "Craque",
          nomeDestinatario: dados.paraNome || "Jogador PK",
          presenteIcone: dados.posterUrl || dados.iconeUrl || media,
          presenteNome: dados.presenteNome || "Presente",
          isLucky: ehLucky,
          multiplicadorGanho: Number(dados.multiplicador || 0),
          quantidadeCombo: Number(dados.quantidadeCombo || 1),
          totalGanhoBolas: Number(dados.totalGanhoBolas || 0)
        };

        // 🟢 Correção Crítica 4.2: Se for um prémio alto de Lucky, ativa o flash verde néon no ecrã para toda a gente
        if (ehLucky && Number(dados.multiplicador || 0) > 1) {
          const uidAlvoDoFlash = dados.paraUid;
          if (uidAlvoDoFlash) {
            setUidVencedorNeonAtivo(uidAlvoDoFlash);
            
            // Desliga o flash após 2.5 segundos de intermitência visual
            if (window.timerFlashNeonLuckys) clearTimeout(window.timerFlashNeonLuckys);
            window.timerFlashNeonLuckys = setTimeout(() => {
              setUidVencedorNeonAtivo(null);
            }, 2500);
          }
        }

              // 🎯 TRANCA SUPREMA DE AUDITORIA: Só entra no letreiro lateral se for estritamente um LUCKY!
        if (ehLucky === true || dados.isLucky === true) {
          setListaAvisosFeed((prev) => [
            ...prev.filter((item) => item.uidRemetente !== uidRemetente),
            dadosCombo,
          ]);

          const cronometro = setTimeout(() => {
            cronometrosDeCartao.delete(cronometro);
            setListaAvisosFeed((prev) => prev.filter((item) => item.id !== idDoc));
          }, 4000);
          cronometrosDeCartao.add(cronometro);
        }

        // ------------------------------------------------------------- SOM
        const ehVideoMP4 = tipoItem === 'mp4' || /\.(mp4|webm|mov)(\?|#|\$)/i.test(String(dados?.videoUrl || ''));

        if (!ehLucky && !ehVideoMP4) {
          try {
            const somBomba = new Audio("/sounds/bomba-explosao.mp3");
            somBomba.volume = 1.0;
            somBomba.play().catch((err) => console.log("Permissão de áudio pendente:", err));
          } catch (errSom) { console.error("Erro ao tocar áudio da bomba:", errSom); }
        }
      });
    }, (erro) => console.error("Escutador de presentes interrompido na Arena:", erro));

    return () => {
      unsubAnim();
      cronometrosDeCartao.forEach(clearTimeout);
      cronometrosDeCartao.clear();
    };
  }, [idBatalha]);

  // O aviso de texto dos Luckys mantém-se com vida própria, fora do render.
  useEffect(() => {
    if (!avisoPresente) return;
    const relogio = setTimeout(() => setAvisoPresente(null), 4000);
    return () => clearTimeout(relogio);
  }, [avisoPresente]);

  // SESSÃO AGORA: entrar/sair do canal num sítio só, com tranca anti-duplo
  // arranque, limite de 15s e teardown garantido ao desmontar.
  const ligacao = useSessaoAgora('JogoPK');

  // REPOR O ESTADO DA PARTIDA.
  // Corre antes de cada partida nova (revanche ou outra batalha). Sem isto,
  // sobravam do jogo anterior o resultado final, os contadores das claques, o
  // chat, o alvo dos presentes e a animação do último presente — e a partida
  // nova arrancava com números que já não eram dela.
  //
  // `limparBatalha` só é usado quando se muda mesmo de batalha: numa revanche o
  // documento é o mesmo, e apagá-lo faria desaparecer as <div> das janelas de
  // vídeo, cortando as câmaras que acabámos de manter vivas de propósito.
  const reporEstadoDaPartida = useCallback((limparBatalha = false) => {
    if (limparBatalha) setBatalha(null);

    setVideoAtivo(null);
    setMensagemJuiz("");
    setMostrarResultadoFinal(false);
    setMostrarOpcoesFim(false);

    setTotalTapTapsArena(0);
    setMoedasStreamerA(0);
    setMoedasStreamerB(0);
    setTapsClaqueA(0);
    setTapsClaqueB(0);
    setMetaClaqueAAtingida(false);
    setMetaClaqueBAtingida(false);

    setMostrarPresentesPK(false);
    setAlvoPresentePK('A');
    setMostrarListaEspectadores(false);
    setMostrarBuscaRivalRapida(false);
    setPesquisaArena("");
  }, []);

  // =========================================================================
// 🔵 MOTOR UNIFICADO GERAL: LUCKYS, STICKERS E VÍDEOS BLINDADOS NA CLOUD (100% SEGURO)
// =========================================================================
const processarEnvioPresente = async (presente, destinatario) => {
  const idDaSalaDestino = idBatalha;
  const meuId = auth.currentUser?.uid;

  if (!presente || !destinatario || !meuId || !idDaSalaDestino) return;

  try {
    const qtdMultiplicador = presente.quantidade || quantidadeSelecionada || 1;
    const campoLadoPontos = alvoPresentePK === 'A' ? "pontosA" : "pontosB";
    
    let totalPremioBolas = 0;
    let maiorMultiplicadorGanho = 0;
    let vezesGanhou = 0;

    const { getFunctions, httpsCallable } = await import('firebase/functions');
    const functionsInstance = getFunctions(undefined, 'europe-west1');

    // =========================================================================
    // 🎡 CAMINHO A: SE FOR LUCKY — CONTROLE TOTAL NO POTE CENTRAL DO SERVIDOR
    // =========================================================================
    if (presente.tipo === 'lucky') {
      const chamarLuckyPK = httpsCallable(functionsInstance, 'processarComboLuckyPKSeguro');
      try {
        const respostaServidor = await chamarLuckyPK({
          presenteLucky: presente,
          idBatalha: idDaSalaDestino,
          quantidadeCombo: qtdMultiplicador,
          uidDestinatario: destinatario.uid,
          campoPontos: campoLadoPontos
        });

        totalPremioBolas = respostaServidor.data.totalPremioBolas;
        maiorMultiplicadorGanho = respostaServidor.data.maiorMultiplicadorGanho;
        vezesGanhou = respostaServidor.data.vezesGanhou;
      } catch (errServidor) {
        if (errServidor.message?.includes("SALDO_INSUFICIENTE")) {
          alert("Saldo insuficiente para esta quantidade de Luckys! ⚽");
        } else {
          alert(errServidor.message || "Erro ao rodar o Lucky na Arena.");
        }
        return;
      }
    } 
    
         // =========================================================================
    // 🖼️ CAMINHO B: SE FOR STICKER — PROCESSAMENTO SEGURO NO SERVIDOR
    // =========================================================================
    else if (presente.tipo === 'sticker' || presente.tipoPresente === 'sticker') {
      const idStkNum = Number(presente.id);
      const idRealBaseDados = idStkNum > 100 ? (idStkNum - 100) : idStkNum;

      if (cromosDesbloqueadosIds.includes(String(idRealBaseDados))) {
        alert("Este sticker já foi completado no álbum deste streamer! Escolha outro. 🏆");
        return;
      }

      const chamarStickerPK = httpsCallable(functionsInstance, 'processarStickerArenaSeguro');
      try {
        await chamarStickerPK({
          idBatalha: idDaSalaDestino,
          uidStreamerApoiar: destinatario.uid,
          idSticker: Number(idRealBaseDados),
          custoStickerBolas: Number(presente.preco),
          nomeSticker: String(presente.nome || "Sticker Especial")
        });

        // 🟢 REMOVIDO O 'RETURN' para deixar o código descer e gravar a animação visual no Firebase!
        setMostrarMenuStickers(false);
      } catch (errSticker) {
        alert(errSticker.message || "Erro ao processar o Sticker na Arena.");
        return;
      }

      // 🟢 INJEÇÃO AUTOMÁTICA E REATIVA NO CHAT DA ARENA (SEM ALTERAR O BACKEND)
      const salaChatId = batalha?.idA || idA;
      if (salaChatId) {
        const { collection: fColl, addDoc: fAddDoc, serverTimestamp: fTime } = await import('firebase/firestore');
        
        let textoMensagemChat = `enviou o Sticker ${presente.nome} para ${destinatario.nome}! 🍀`;

        await fAddDoc(fColl(db, "chatsArena", salaChatId, "chat"), {
          tipo: "presente",
          texto: textoMensagemChat,
          uid: auth.currentUser?.uid,
          nome: auth.currentUser?.displayName || "Craque",
          foto: auth.currentUser?.photoURL || "/hero.png",
          criadoEm: fTime(),
          nivelAdepto: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' ? calcularNivel(userDados?.xpAdepto || 0) : 1,
          nivelJogador: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' ? calcularNivel(userDados?.xpJogador || 0) : 1
        }).catch(e => console.error("Erro ao injetar sticker no chat da Arena:", e));
      }
    }

    // =========================================================================
    // 🎥 CAMINHO C: SE FOR PRESENTE DE VÍDEO — PROCESSAMENTO SEGURO NO SERVIDOR
    // =========================================================================
    else {
      const chamarVideoPK = httpsCallable(functionsInstance, 'processarPresenteVideoPKSeguro');
      try {
        await chamarVideoPK({
          batalhaId: idDaSalaDestino,
          idAlvo: destinatario.uid,
          precoBolas: presente.preco * qtdMultiplicador,
          videoUrl: presente.video || "",
          campoPontos: campoLadoPontos
        });
      } catch (errVideo) {
        alert(errVideo.message || "Erro ao processar presente de vídeo na Arena.");
        return;
      }
    }

      // ========================================================
    // ENVIAR XP AUTOMÁTICO PARA O FIREBASE DIRECTAMENTE DA ARENA PK
    // ========================================================
    const custoFinalBolasArena = presente.preco * qtdMultiplicador;
    const meuUidArena = auth?.currentUser?.uid;

    // 1. Dá XP de Adepto ao utilizador autenticado que enviou
    if (meuUidArena) {
      adicionarXP(meuUidArena, 'adepto', custoFinalBolasArena);
    }

    // 2. Dá XP de Jogador ao Streamer destinatário que recebeu o apoio na batalha
    if (destinatario?.uid && destinatario.uid !== meuUidArena) {
      adicionarXP(destinatario.uid, 'jogador', custoFinalBolasArena);
    }
    // ========================================================

    // =========================================================================
    // 🔥 REGISTO DE ANIMAÇÃO UNIFICADO (COLECÇÃO SAGRADA: "batalhasAtivas")
    // =========================================================================
    const { collection: fColl, addDoc: fAddDoc, updateDoc: fUpdateDoc, serverTimestamp: fTimestamp, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
    
    const animRef = fColl(db, "batalhasAtivas", idDaSalaDestino, "animacoes_presentes");
    const docAnimacao = await fAddDoc(animRef, {
      videoUrl: presente.video || "",
      iconeUrl: presente.icone || "",
      posterUrl: presente.icone || "",
      presenteNome: presente.nome,
      tipo: presente.tipo || "",
      deUid: meuId,
      deNome: auth.currentUser?.displayName || "Adepto",
      deFoto: auth.currentUser?.photoURL || "",
      paraUid: destinatario.uid,
      paraNome: destinatario.nome || "Jogador PK",
      alvoLadoPK: alvoPresentePK, 
      criadoEm: fTimestamp(),
      isLucky: presente.tipo === 'lucky',
      quantidadeCombo: qtdMultiplicador,
      multiplicador: maiorMultiplicadorGanho,
      totalGanhoBolas: totalPremioBolas,
      ganhouLucky: totalPremioBolas > 0
    });

    await fUpdateDoc(docAnimacao, { id: docAnimacao.id, chave: docAnimacao.id }).catch(() => {});

    // Limpeza automática da animação após 25 segundos para não sobrecarregar o ecrã
    setTimeout(() => {
      fDeleteDoc(docAnimacao).catch(() => {});
    }, 25000);

    // FEEDBACK VISUAL DOS LUCKYS NO ECRÃ DO UTILIZADOR
    if (presente.tipo === 'lucky') {
      if (totalPremioBolas > 0) {
        setAvisoPresente(`⚡ LUCKYS: Rodaste ${qtdMultiplicador}x! O teu maior multiplicador foi de ${maiorMultiplicadorGanho}x. Ganhaste ${totalPremioBolas} ⚽!`);
      } else {
        setAvisoPresente(`⚡ LUCKYS: Rodaste ${qtdMultiplicador}x mas a sorte não esteve contigo! Tenta de novo. 🔥`);
      }
      setQuantidadeSelecionada(1);
    }

        // 🚀 ATIVAÇÃO DO COMBO VISUAL (BOLINHA ROSA) - APENAS SE NÃO FOR STICKER
    if (presente.tipo !== 'sticker' && presente.tipoPresente !== 'sticker') {
      setComboPresenteAtivo(presente);
      setComboDestinatarioAtivo(destinatario);

      const tamanhoDoBlocoReal = presente.quantidade || quantidadeSelecionada || 1;
      const novoValorAcumulado = contagemComboCliques === 0 ? tamanhoDoBlocoReal : (contagemComboCliques + tamanhoDoBlocoReal);
      
      setContagemComboCliques(novoValorAcumulado);
      setMostrarBolinhaRosa(true);

      if (window.timerComboBancada) clearTimeout(window.timerComboBancada);
      window.timerComboBancada = setTimeout(() => {
        setMostrarBolinhaRosa(false);
        setContagemComboCliques(0);
      }, 3000);
    }

  } catch (e) { 
    console.error("Erro crítico geral no processamento de presentes da Arena PK:", e); 
  }
};

  // Batalha nova (id diferente): limpa tudo, incluindo o documento antigo.
  useEffect(() => {
    reporEstadoDaPartida(true);
  }, [idBatalha, reporEstadoDaPartida]);

    // AVISO DIÁRIO DE NOVIDADES DO ESTÁDIO (uma vez por dia, hora local)
  const [mostrarAvisoEstadio, setMostrarAvisoEstadio] = useState(false);

  useEffect(() => {
    // Este efeito NUNCA repõe o estado a false. Em StrictMode o React monta,
    // desmonta e volta a montar: na 2ª passagem o dia já ficou gravado, o
    // shouldShow devolve false e saímos aqui — se em vez disso chamássemos
    // setMostrarAvisoEstadio(false), o popup abria e fechava-se sozinho.
    if (!shouldShowStadiumUpdate()) return;
    markStadiumUpdateShown();
    setMostrarAvisoEstadio(true);
  }, []);

  // SISTEMA DE ENVIO DE PRESENTES BLINDADO VIA CLOUD FUNCTION + CHAT (5-0!)
  const enviarPresente = async (presente, receptorID) => {
    // Se não estiver em campo jogando as partes, ignora por completo o clique do espetador
    if (!batalha || (batalha.fase !== "1ª PARTE" && batalha.fase !== "2ª PARTE")) return;

        // 💡 VALIDAÇÃO CRÍTICA DO STICKER DOADO: Impede que o espetador envie um sticker que já foi completado!
    const ehSticker = presente.tipo === 'sticker' || presente.tipoPresente === 'sticker';
    if (ehSticker && cromosDesbloqueadosIds.includes(String(presente.id))) {
      alert("Este sticker já foi doado e preenchido no álbum do streamer! 🏆");
      return;
    }

    // Resolve o formato do objeto destinatário para bater certo com o motor unificado
    const nomeReceptor = receptorID === batalha.idA
      ? (batalha.nomeA || "Jogador A")
      : (batalha.nomeB || "Jogador B");
    
    const destinatarioEfetivo = {
      uid: receptorID,
      nome: nomeReceptor
    };

    // 🚀 Redireciona para o Motor Unificado Geral que trata de Luckys, Stickers e Combos
    await processarEnvioPresente(presente, destinatarioEfetivo);

    // 4. AVISO DOURADO VIP NO CHAT DA ARENA
    const salaChatId = batalha?.idA || idA;
    if (salaChatId) {
      const { collection: fColl, addDoc: fAddDoc, serverTimestamp: fTime } = await import('firebase/firestore');
      
      let textoMensagemChat = `enviou ${presente.nome} para ${nomeReceptor}!`;
      if (presente.tipo === 'lucky') {
        textoMensagemChat = `ativou o Lucky ${presente.nome} para ${nomeReceptor}! ⚡`;
      }

      await fAddDoc(fColl(db, "chatsArena", salaChatId, "chat"), {
        tipo: "presente",
        texto: textoMensagemChat,
        uid: auth.currentUser?.uid,
        nome: auth.currentUser?.displayName || "Craque",
        foto: auth.currentUser?.photoURL || "/hero.png",
        criadoEm: fTime()
      }).catch(e => console.error("Erro ao injetar alerta de presente no chat:", e));
    }
  };

  // TRANCADOR DE ECRÃ: o ecrã não apaga durante a partida. Vive no seu próprio
  // efeito porque não tem nada a ver com o vídeo — antes estava misturado com o
  // arranque do Agora e por isso não era libertado quando a entrada falhava.
  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        if ('wakeLock' in navigator && !wakeLockRef.current) {
          const tranca = await navigator.wakeLock.request('screen');
          if (!ativo) { tranca.release().catch(() => {}); return; }
          wakeLockRef.current = tranca;
        }
      } catch (err) { console.log("Erro ao trancar ecrã:", err); }
    })();

    return () => {
      ativo = false;
      if (wakeLockRef.current) {
        wakeLockRef.current.release().catch(() => {});
        wakeLockRef.current = null;
      }
    };
  }, [idBatalha]);

  // ENTRADA NO CANAL DE VÍDEO.
  // `ligacao.tentativa` está nas dependências: é o que faz o botão TENTAR DE
  // NOVO voltar a correr isto. Quando a chave da partida muda (nova revanche),
  // o efeito também volta a correr e o gestor fecha o canal antigo antes de
  // abrir o novo — nunca há dois joins sobrepostos.
  useEffect(() => {
    if (!idBatalha || idBatalha === "undefined" || auth.currentUser?.uid == null) return;

    const entrarNoCampo = async () => {
      // Token da Cloud Function. Se não vier, entra em modo App ID para o vídeo
      // nunca ficar preto — mesmo comportamento que a LiveCampo.
      let tokenReal = null;
      try {
        const chamarGerador = httpsCallable(functions, 'gerarTokenAgora');
        const resultadoServidor = await chamarGerador({ idBatalha });
        tokenReal = resultadoServidor?.data?.token || null;
      } catch (eToken) {
        console.log("Token Agora indisponível, a entrar em modo App ID:", eToken?.message);
      }

      // Lugares determinísticos vindos do mapa: quem for o idA é sempre o uid 1
      // (janela esquerda) e o adversário é sempre o uid 2 (janela direita).
      // Nunca por ordem de chegada.
      const chaveDaPartida = { idA };
      const uidAgoraJogo = espectador ? null : uidAgoraDoUtilizador(chaveDaPartida, auth.currentUser?.uid);

      await ligacao.entrar({
        appId: AGORA_APP_ID,
        canal: idBatalha,
        token: tokenReal,
        uid: uidAgoraJogo,
        publicar: !espectador,
        // A minha própria câmara vai para a MINHA janela — que é a esquerda se
        // eu for o anfitrião e a direita se eu for o adversário.
        contentorLocal: espectador ? null : contentorLocalDoUtilizador(chaveDaPartida, auth.currentUser?.uid),
        aoPublicarRemoto: (utilizador, tipoMedia) => {
          if (tipoMedia === "video") {
            // Uma só regra para jogadores e espetadores: a janela vem do uid.
            // Antes, um jogador atirava QUALQUER publicador remoto para a
            // janela-rival sem olhar ao uid.
            const contentor = contentorDeRemoto(utilizador.uid);
            if (contentor) reproduzirVideoNoContentor(utilizador.videoTrack, contentor);
          }
          if (tipoMedia === "audio") utilizador.audioTrack?.play();
        },
        aoDespublicarRemoto: (utilizador, tipoMedia) => {
          // Quem sai leva a sua janela com ele. Numa revanche com adversário
          // novo, sem isto ficava o último fotograma do rival anterior colado
          // por baixo do nome do rival novo.
          if (tipoMedia === "video") limparContentorDeRemoto(utilizador.uid);
        },
      });
    };

    entrarNoCampo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idBatalha, espectador, idA, ligacao.tentativa]);

    // LÓGICA DO OLHINHO (CONTAGEM DE GENTE NO ESTÁDIO)
  const [totalGente, setTotalGente] = useState(0);

    // SENSOR: Verifica estatuto vitalício e conta membros reais ativos com query filtrada
  useEffect(() => {
    if (!batalha?.idA || !auth.currentUser?.uid) return;

    const meuUidLogado = auth.currentUser.uid;
    let unsubMembrosA = null;
    let unsubMembrosB = null;

    const iniciarSensoresMembros = async () => {
      try {
        const { doc: fDoc, getDoc: fGetDoc, collection: fColl, onSnapshot: fOnSnapshot, query: fQuery, where: fWhere } = await import('firebase/firestore');
        
        // 1. VERIFICAÇÃO INDIVIDUAL DE PERTENÇA NA CLAQUE DE BATALHAS
        const docClaqueARef = fDoc(db, "utilizadores", batalha.idA, "claque_batalhas_membros", meuUidLogado);
        const snapA = await fGetDoc(docClaqueARef);
        setEuPertencoAClaqueA(snapA.exists() && snapA.data()?.ativo === true);

        if (batalha.idB) {
          const docClaqueBRef = fDoc(db, "utilizadores", batalha.idB, "claque_batalhas_membros", meuUidLogado);
          const snapB = await fGetDoc(docClaqueBRef);
          setEuPertencoAClaqueB(snapB.exists() && snapB.data()?.ativo === true);
        }

                // 2. ESCUTA EM TEMPO REAL APENAS MEMBROS COM ATIVO === TRUE (CLAQUE A)
        const claqueACollRef = fColl(db, "utilizadores", batalha.idA, "claque_batalhas_membros");
        const qClaqueA = fQuery(claqueACollRef, fWhere("ativo", "==", true));
        unsubMembrosA = fOnSnapshot(qClaqueA, (snapCollA) => {
          setTotalMembrosClaqueA(snapCollA.size);
          setIdsClaqueA(snapCollA.docs.map(d => d.id)); // Armazena os IDs dos sócios do Streamer A
        });

        // 3. ESCUTA EM TEMPO REAL APENAS MEMBROS COM ATIVO === TRUE (CLAQUE B)
        if (batalha.idB) {
          const claqueBCollRef = fColl(db, "utilizadores", batalha.idB, "claque_batalhas_membros");
          const qClaqueB = fQuery(claqueBCollRef, fWhere("ativo", "==", true));
          unsubMembrosB = fOnSnapshot(qClaqueB, (snapCollB) => {
            setTotalMembrosClaqueB(snapCollB.size);
            setIdsClaqueB(snapCollB.docs.map(d => d.id)); // Armazena os IDs dos sócios do Streamer B
          });
        }

      } catch (errCheck) {
        console.error("Erro ao processar sensores de membros na Arena:", errCheck);
      }
    };

    iniciarSensoresMembros();

    return () => {
      if (unsubMembrosA) unsubMembrosA();
      if (unsubMembrosB) unsubMembrosB();
    };
  }, [batalha?.idA, batalha?.idB]);

  useEffect(() => {
    if (!idBatalha) return;

    const meuUidLogado = auth.currentUser?.uid;
    if (!meuUidLogado) return;
    
    const idA_Atual = batalha ? batalha.idA : idA;
    const idB_Atual = batalha ? batalha.idB : null;
    const euSouLutador = meuUidLogado === idA_Atual || meuUidLogado === idB_Atual;
    const presencaRef = doc(db, "batalhasAtivas", idBatalha, "presencas", meuUidLogado);

        // Regista a presença de toda a gente (Adeptos e Streamers) no estádio
            setDoc(presencaRef, { 
      uid: meuUidLogado,
      nome: auth.currentUser?.displayName || "Craque", 
      foto: auth.currentUser?.photoURL || "",
      cargo: meuUidLogado === idA_Atual ? "Streamer A" : (meuUidLogado === idB_Atual ? "Streamer B" : "Adepto"),
      bancada: alvoPresentePK, 
      entrada: serverTimestamp() 
    }, { merge: true }).catch(() => {});

    // ESCUTADOR AUTOMÁTICO DE EXPULSÃO: Se o streamer apagar a presença do adepto, ele cai na hora!
    let unsubExpulsao = null;
    if (!euSouLutador) {
      unsubExpulsao = onSnapshot(presencaRef, (docSnap) => {
        if (!docSnap.exists() && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") {
          alert("Saíste da bancada com sucesso");
          if (unsubExpulsao) unsubExpulsao();
          if (typeof aoSair === 'function') aoSair();
          else window.location.href = '/?app';
        }
      });
    }

    // TRANCA MESTRE: Se o utilizador fechar a aba, mudar de app ou desligar o ecrã, limpa na hora
    const limparPresencaAoFecharJanela = () => {
      // Toda a gente, lutadores incluídos. Antes só os adeptos saíam da lista,
      // por isso um lutador que fechasse o separador ficava "presente" para
      // sempre — e o relógio nunca passava para o outro.
      deleteDoc(presencaRef).catch(() => {});
    };

    window.addEventListener("beforeunload", limparPresencaAoFecharJanela);
    window.addEventListener("pagehide", limparPresencaAoFecharJanela);

    const q = collection(db, "batalhasAtivas", idBatalha, "presencas");
    const unsub = onSnapshot(q, (snap) => {
      const listaDocs = snap.docs.map(d => d.data());
      setListaEspectadores(listaDocs);
      setTotalGente(snap.size); 
    });

        return () => {
      if (unsubExpulsao) unsubExpulsao(); // LIMPA O ESCUTADOR DE BAN DA MEMÓRIA

      deleteDoc(presencaRef).catch(() => {});
      window.removeEventListener("beforeunload", limparPresencaAoFecharJanela);
      window.removeEventListener("pagehide", limparPresencaAoFecharJanela);
      unsub();
    };
    // CORRIGIDO: Adicionado alvoPresentePK para atualizar a bancada em tempo real na base de dados
  }, [idBatalha, batalha?.idA, batalha?.idB, espectador, alvoPresentePK]);

      // ESCUTADOR DA BATALHA EM TEMPO REAL (MANTÉM OS GOLOS ATUALIZADOS PARA TODOS)
  useEffect(() => {
    if (!idBatalha) return;

    const unsub = ligacao.registarListener(onSnapshot(doc(db, "batalhasAtivas", idBatalha), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        
        // Sincroniza os Tap Taps normais e os contadores de cada claque na Arena
        setTotalTapTapsArena(data.totalTapTaps || 0);
                setMoedasStreamerA(data.pontosA || 0);
        setMoedasStreamerB(data.pontosB || 0);
        
        const CliquesClaqueA = Number(data.tapsClaqueA || 0);
        const CliquesClaqueB = Number(data.tapsClaqueB || 0);
        setTapsClaqueA(CliquesClaqueA);
        setTapsClaqueB(CliquesClaqueB);
        setMetaClaqueAAtingida(CliquesClaqueA >= 5000);
        setMetaClaqueBAtingida(CliquesClaqueB >= 5000);

        // Evita crash de reload disparando a animação apenas se o estado anterior já existia
        setBatalha(prevBatalha => {
          if (prevBatalha && data.ultimoVideo && data.ultimoVideo !== prevBatalha.ultimoVideo) {
            setVideoAtivo(data.ultimoVideo);
          }
          return data;
        });

        // DISPARA O JOGO AUTOMATICAMENTE QUANDO OS DOIS CLICAM EM PRONTO
        if (data.fase === "ESPERA" && data.prontoA && data.prontoB && auth.currentUser.uid === data.idA) {
          updateDoc(doc(db, "batalhasAtivas", idBatalha), { 
            fase: "1ª PARTE", 
            tempo: 180,
            pontosA: 0, pontosB: 0,
            golosA: 0, golosB: 0,
            totalTapTaps: 0,
            tapsClaqueA: 0, // Inicializa as duas claques a zero no arranque da partida
            tapsClaqueB: 0
          }).then(() => {
            // AVISAR A CLAQUE QUE A BATALHA COMEÇOU
            getDocs(collection(db, "utilizadores", auth.currentUser.uid, "seguidores")).then((segSnap) => {
              segSnap.forEach((seguidor) => {
                try {
                  enviarNotificacao(seguidor.id, auth.currentUser.uid, auth.currentUser.displayName || "Craque", "arena_pk", { batalhaId: idBatalha });
                } catch(e) {}
              });
            });
          }).catch(err => console.error(err));
        }
      }
    }));
    return () => unsub();
  }, [idBatalha]);

    // ===========================================================================
  // ⚽ MOTOR DE ARBITRAGEM: CÁLCULO AUTOMÁTICO DE GOLOS POR CADA 1000 PONTOS
  // ===========================================================================
  useEffect(() => {
    // Só roda o cálculo o Criador da Sala (idA) para não haver escritas duplicadas no Firebase
    if (!batalha || auth.currentUser?.uid !== idA) return;
    if (batalha.fase !== "1ª PARTE" && batalha.fase !== "2ª PARTE") return;

    const ptsA = Number(batalha.pontosA || 0);
    const ptsB = Number(batalha.pontosB || 0);

    // Calcula matematicamente quantos golos cada lado deve ter (1 golo por cada 1000 redondos)
    const golosCalculadosA = Math.floor(ptsA / 1000);
    const golosCalculadosB = Math.floor(ptsB / 1000);

    const golosAtuaisA = Number(batalha.golosA || 0);
    const golosAtuaisB = Number(batalha.golosB || 0);

    // Se houver alteração nos golos de qualquer um dos lados, atualiza o placard mundial
    if (golosCalculadosA !== golosAtuaisA || golosCalculadosB !== golosAtuaisB) {
      updateDoc(doc(db, "batalhasAtivas", idBatalha), {
        golosA: golosCalculadosA,
        golosB: golosCalculadosB
      }).catch(err => console.error("Erro ao computar golo automático na Arena:", err));
    }
  }, [batalha?.pontosA, batalha?.pontosB, batalha?.fase, idA, idBatalha]);

  // VIGIA DO RELÓGIO.
  // Guarda o instante em que o `tempo` mudou pela última vez. Se ele deixar de
  // andar, é porque o árbitro (o Jogador A) desapareceu — foi exatamente isto
  // que deixou partidas congeladas no mesmo segundo para sempre.
  //
  // A versão anterior olhava para a lista de presenças, mas isso não chegava:
  // uma presença que tenha ficado para trás no Firestore faz parecer que o A
  // ainda lá está, e o relógio nunca era resgatado. Olhar para o relógio em si
  // não engana — ou ele anda, ou não anda.
  const ultimoTiqueRef = useRef({ tempo: null, em: Date.now() });
  const [relogioParado, setRelogioParado] = useState(false);

  useEffect(() => {
    if (!batalha) return;
    if (batalha.tempo !== ultimoTiqueRef.current.tempo) {
      ultimoTiqueRef.current = { tempo: batalha.tempo, em: Date.now() };
      setRelogioParado(false);
    }
  }, [batalha?.tempo, batalha]);

  useEffect(() => {
    const emJogo = batalha?.fase && batalha.fase !== "ESPERA" && batalha.fase !== "FIM";
    if (!emJogo) { setRelogioParado(false); return; }

    const vigia = setInterval(() => {
      setRelogioParado(Date.now() - ultimoTiqueRef.current.em > 10000);
    }, 2000);
    return () => clearInterval(vigia);
  }, [batalha?.fase]);

  // JUIZ MESTRE: quem faz correr o relógio no Firebase.
  // O Jogador A apita sempre. O B só pega no apito se o relógio estiver parado
  // há mais de 10 segundos — enquanto o A estiver a apitar, o tempo muda e o
  // vigia acima nunca dispara, por isso não há dois relógios ao mesmo tempo.
  useEffect(() => {
    if (!batalha) return;
    const meuUid = auth.currentUser?.uid;
    const souOArbitro = meuUid === batalha.idA
      || (meuUid === batalha.idB && relogioParado);
    if (!souOArbitro) return;

    let t;
    if (batalha.fase !== "ESPERA" && batalha.fase !== "FIM") {
      t = setInterval(() => {
        if (batalha.tempo <= 1) {
          let novaFase = "";
          let novoTempo = 0;

          if (batalha.fase === "1ª PARTE") { novaFase = "INTERVALO"; novoTempo = 60; }
          else if (batalha.fase === "INTERVALO") { novaFase = "2ª PARTE"; novoTempo = 180; }
          else if (batalha.fase === "2ª PARTE") { novaFase = "FIM"; novoTempo = 0; }

          updateDoc(doc(db, "batalhasAtivas", idBatalha), {
            fase: novaFase, tempo: novoTempo, ultimoTiqueEm: serverTimestamp(),
          }).catch(e => console.log(e));
        } else {
          // O `ultimoTiqueEm` vai na mesma escrita (não custa nada) e é o que
          // permite ao servidor saber, mais tarde, que esta partida morreu.
          // Em transação: se a partida acabou ou parou entretanto (alguém saiu e
          // escreveu tempo: 0), não desconta. Era este cruzamento que dava "-1:-1".
          runTransaction(db, async (tx) => {
            const ref = doc(db, "batalhasAtivas", idBatalha);
            const atual = await tx.get(ref);
            const proximo = proximoTique(atual.exists() ? atual.data() : null);
            if (proximo) tx.update(ref, { ...proximo, ultimoTiqueEm: serverTimestamp() });
          }).catch(e => console.log(e));
        }
      }, 1000);
    }
    return () => clearInterval(t);
  }, [batalha?.fase, batalha?.tempo, batalha?.idA, batalha?.idB, idBatalha, relogioParado]);

  // TIMEOUTS DE MENSAGENS E SINALIZAÇÃO DOS APITOS PARA JOGADORES E ESPETADORES
  useEffect(() => {
    if (!batalha?.fase) return;

    if (batalha.fase === "1ª PARTE") {
      setMensagemJuiz("1ª PARTE - APITO INICIAL!");
      setMostrarResultadoFinal(false);
      setMostrarOpcoesFim(false);
    }
    else if (batalha.fase === "INTERVALO") {
      setMensagemJuiz("INTERVALO!");
    }
    else if (batalha.fase === "2ª PARTE") {
      setMensagemJuiz("2ª PARTE - INICIADA!");
    }
        else if (batalha.fase === "FIM") {
      setMensagemJuiz("JOGO TERMINADO!");
      
      let timeoutOpcoes;
      const timeoutJuiz = setTimeout(() => {
        setMensagemJuiz(""); 
        setMostrarResultadoFinal(true);
        
        timeoutOpcoes = setTimeout(() => {
          setMostrarOpcoesFim(true); // Liberta os botões de Revanche / Sair (sem tapar o resultado)
        }, 4000);
      }, 3000);

      return () => { clearTimeout(timeoutJuiz); clearTimeout(timeoutOpcoes); };
    }
    
    if (batalha.fase !== "FIM") {
      const timeoutLimpeza = setTimeout(() => setMensagemJuiz(""), 3000);
      return () => clearTimeout(timeoutLimpeza);
    }
  }, [batalha?.fase]);

    // LER MENSAGENS DA BATALHA EM TEMPO REAL
    useEffect(() => {
    if (!idA) return;
    const q = query(collection(db, "chatsArena", idA, "chat"), orderBy("criadoEm", "asc"));
    
    const unsub = onSnapshot(q, (snap) => {
      setMensagensChat(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, [idA]);

  // Novo hook dedicado exclusivamente a empurrar o chat para baixo a cada mensagem nova
  useEffect(() => {
    scrollToBottom();
  }, [mensagensChat.length]);

  const enviarMensagemBatalha = async () => {
  if (!textoMensagem.trim() || !idA) return;

  try {
    const { collection, addDoc, serverTimestamp } = await import('firebase/firestore');
    
    // Totalmente independente de variáveis de estado: lê direto do utilizador logado no Firebase
    const fotoReal = auth.currentUser?.photoURL || '/hero.png';
    const nomeReal = auth.currentUser?.displayName || "Craque";

    await addDoc(collection(db, "chatsArena", idA, "chat"), {
      texto: textoMensagem,
      uid: auth.currentUser?.uid,
      nome: nomeReal,
      foto: fotoReal,
      tipo: "texto",
      criadoEm: serverTimestamp(),
      
      // Blindagem de Produção: Se o ecrã não tiver o XP local, envia 1 por defeito para nunca dar erro
      nivelAdepto: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' ? calcularNivel(userDados?.xpAdepto || 0) : 1,
      nivelJogador: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' ? calcularNivel(userDados?.xpJogador || 0) : 1
    });

    // Limpa a caixa de texto após o envio com sucesso
    setTextoMensagem("");
  } catch (errChat) {
    console.error("Erro ao enviar mensagem na arena:", errChat);
  }
};

  // O botão só regista a INTENÇÃO do utilizador. Quem a aplica à pista é o
  // efeito abaixo. Antes, o botão mexia na pista e no estado ao mesmo tempo:
  // se depois nascesse uma pista nova (entrada repetida, revanche, TENTAR DE
  // NOVO), ela vinha ligada de fábrica enquanto o botão continuava a dizer
  // "silenciado" — era preciso carregar duas vezes para voltar a calar.
  const alternarMicrofoneBatalha = () => setMicroLigado((ligado) => !ligado);

  // Aplica a intenção do microfone à pista atual — e volta a aplicá-la sempre
  // que a ligação muda de estado (ou seja, sempre que há uma pista nova).
  useEffect(() => {
    const pistaAudio = ligacao.sessao.audio;
    if (!pistaAudio) return;
    // setMuted e não setEnabled: o setEnabled(false) DESPUBLICA a pista, e o
    // adversário recebia um user-unpublished como se tivéssemos saído. O
    // setMuted mantém a pista publicada, apenas silenciada.
    Promise.resolve(pistaAudio.setMuted(!microLigado))
      .catch((err) => console.error("Erro ao alternar microfone na Arena:", err));
  }, [microLigado, ligacao.estado, ligacao.sessao]);

  // =========================================================================
// 🏟️ CORREÇÃO DA ASSINATURA DE NOTIFICAÇÃO EM MASSA
// =========================================================================
const partilharBatalhaReal = async () => {
    try {
      const link = "https://gamefutlive.com"; // O teu link real de produção
      const texto = `Vem apoiar-me na Arena PK! O jogo está ao rubro no Estádio! 🏟️⚽`;
      
      try {
        const { collection, getDocs, query, where } = await import('firebase/firestore');
        const meuIdAtual = auth.currentUser?.uid;
        
        if (meuIdAtual) {
          const segSnap = await getDocs(query(collection(db, "seguidores"), where("seguindoUid", "==", meuIdAtual)));
          const segDocs = segSnap.docs.map(d => d.data().seguidorUid).filter(Boolean);

          const seguidosSnap = await getDocs(query(collection(db, "seguidores"), where("seguidorUid", "==", meuIdAtual)));
          const seguidosDocs = seguidosSnap.docs.map(d => d.data().seguindoUid).filter(Boolean);

          const listaNotificar = [...new Set([...segDocs, ...seguidosDocs])];

          const meuNome = auth.currentUser?.displayName || "Um craque";
          const minhaFoto = auth.currentUser?.photoURL || "";

          for (const uidAlvo of listaNotificar) {
            // CORRIGIDO: Alinhado com a assinatura padrão (Destinatario, Remetente, Nome, Tipo, Extras) para não falhar
            await enviarNotificacao(
              uidAlvo, 
              meuIdAtual, 
              meuNome, 
              "arena_pk", 
              { 
                batalhaId: idBatalha, 
                fotoRemetente: minhaFoto,
                tituloCustomizado: "Arena PK ao Vivo! 🏟️🟥🟦",
                mensagemCustomizada: `${meuNome} entrou em batalha e precisa do teu apoio! Entra no Estádio.`
              }
            );
          }
        }
      } catch (errNotif) {
        console.error("Erro ao disparar notificações em massa da Arena:", errNotif);
      }

      if (navigator.share) {
        await navigator.share({
          title: 'Batalha na Arena 🏟️⚽',
          text: texto,
          url: link,
        });
      } else {
        alert("Link copiado para a área de transferência! 📋");
        navigator.clipboard.writeText(`${texto} ${link}`);
      }
    } catch (e) { 
      console.error("Erro ao processar partilha:", e); 
    }
  };

      // CORREÇÃO CIRÚRGICA DE PRODUÇÃO: Limpa a memória das câmaras velhas e inicia o jogo direto
  const reiniciarBatalha = async () => {
    try {
      // Estado limpo antes de cada revanche — mas mantendo `batalha`, para as
      // janelas de vídeo não serem desmontadas.
      reporEstadoDaPartida(false);
      
      // NÃO se mexe na ligação Agora: a revanche é no mesmo canal, e os dois
      // jogadores continuam em campo entre partidas. Derrubar a sessão aqui era
      // o que deixava o vídeo preto na revanche — o efeito de entrada depende
      // de idBatalha, que não muda, por isso nunca voltava a ligar as câmaras.

            // APENAS INTERRUPTOR DE PONTUAÇÃO: Roda apenas para o Criador (idA) para limpar o placar no Firebase
      if (auth.currentUser.uid === idA) {
        await updateDoc(doc(db, "batalhasAtivas", idBatalha), {
          pontosA: 0,
          pontosB: 0,
          golosA: 0,
          golosB: 0,
          tapsClaqueA: 0, // 💡 Limpa os cliques acumulados da Claque A para a revanche
          tapsClaqueB: 0, // 💡 Limpa os cliques acumulados da Claque B para a revanche
          prontoA: true, 
          prontoB: true, 
          fase: "1ª PARTE", // Salta direto para o jogo para manter o vídeo do Agora.io ativo
          tempo: 180, // Reinicia os 3 minutos da primeira parte
          ultimoVideo: null
        });

        // Limpa o histórico de chat da sala para o novo jogo começar do zero
        try {
          const chatSnap = await getDocs(query(collection(db, "chatsArena", idA, "chat")));
          const delecoes = chatSnap.docs.map(d => deleteDoc(d.ref));
          await Promise.all(delecoes);
        } catch(e) {}
      }

    } catch (err) {
      console.error("Erro ao fazer o reset de pontos:", err);
    }
  };

    // RADAR EM TEMPO REAL: Escuta novos stickers vindos do servidor e mostra no ecrã
  useEffect(() => {
    if (!idBatalha) return;

    let cancelou = false;
    let escutador = null;

    const inicializarRadarStickers = async () => {
      try {
        const { collection: fCollection, query: fQuery, orderBy: fOrderBy, limit: fLimit, onSnapshot: fOnSnapshot } = await import('firebase/firestore');
        
        const stickersRef = fCollection(db, "batalhasAtivas", idBatalha, "animacoesStickers");
        const consulta = fQuery(stickersRef, fOrderBy("criadoEm", "desc"), fLimit(1));

        escutador = fOnSnapshot(consulta, (snapshot) => {
          if (cancelou || snapshot.empty) return;

          const docNovo = snapshot.docs[0];
          const dados = docNovo.data();

          // Evita processar stickers muito antigos se a página acabou de carregar
          if (!dados.criadoEm) return;

          // Tranca de Auditoria: Ignora stickers enviados há mais de 10 segundos (evita o bug ao entrar)
const dataDoSticker = dados.criadoEm?.toMillis() ?? 0;
if (Date.now() - dataDoSticker > 10000) return;


                    // Cruza o ID do servidor com a lista local de forma 100% matemática e dinâmica
          const stickerMapeado = LISTA_STICKERS.find(s => {
            const idMapeadoNum = Number(s.id);
            const idMapeadoLimpo = idMapeadoNum > 100 ? (idMapeadoNum - 100) : idMapeadoNum;
            const idServidorReal = Number(dados.idSticker || dados.stickerId || 0);
            return idMapeadoLimpo === idServidorReal;
          });

          if (stickerMapeado) {
            setStickerAtivo({
              ...stickerMapeado,
              campoStreamer: dados.campoStreamer || (dados.alvoLadoPK || 'A')
            });

            // Apaga o sticker do ecrã após 3 segundos (tempo da animação)
            setTimeout(() => {
              if (!cancelou) setStickerAtivo(null);
            }, 3000);
          }
        });
      } catch (err) {
        console.error("Erro no radar de stickers:", err);
      }
    };

    inicializarRadarStickers();

    return () => {
      cancelou = true;
      if (typeof escutador === 'function') escutador();
    };
  }, [idBatalha]);
  
      // ===========================================================================
  // 🔵 ENVIAR STICKER NA ARENA PK (INTEGRADO COM O MOTOR MESTRE UNIFICADO)
  // ===========================================================================
  const enviarStickerPK = async (idDoSticker, precoDoSticker, nomeDoSticker, uidStreamerAlvo) => {
    const meuUid = auth.currentUser?.uid;

    if (!idBatalha || !meuUid || !uidStreamerAlvo) {
      alert("Selecione o streamer que queres apoiar!");
      return;
    }

    if (meuUid === uidStreamerAlvo) {
      alert("Estás a consultar o teu álbum em modo leitura. Não podes enviar stickers a ti próprio! 🏆");
      return;
    }

    // Monta o objeto no padrão mestre que o teu processarEnvioPresente espera
    const stickerObjeto = {
      id: Number(idDoSticker),
      preco: Number(precoDoSticker),
      nome: String(nomeDoSticker),
      tipo: 'sticker'
    };

    const destinatarioEfetivo = {
      uid: uidStreamerAlvo,
      nome: uidStreamerAlvo === batalha?.idA ? (batalha?.nomeA || "Jogador A") : (batalha?.nomeB || "Jogador B")
    };

    // Dispara o motor blindado que trata do Firebase, Trancas de Álbum e distribui o XP!
    await processarEnvioPresente(stickerObjeto, destinatarioEfetivo);
    setMostrarMenuStickers(false);
  };
  
  // ===========================================================================
// 🔵 ADESÃO À CLAQUE DO STREAMER A (CORRIGIDO E SINCRONIZADO VISUALMENTE)
// ===========================================================================
const comprarAbonoClaqueA = async () => {
  if (!batalha?.idA || !auth.currentUser?.uid) return;
  const meuUidLogado = auth.currentUser.uid;
  const nomeDinamicoA = batalha.nomeA || "Streamer";

  try {
    const { httpsCallable, getFunctions } = await import('firebase/functions');
    const fFunctions = getFunctions(undefined, 'europe-west1');

    const chamarClaqueServidor = httpsCallable(fFunctions, 'processarClaqueArenaSegura');
    const resposta = await chamarClaqueServidor({
      idBatalha: idBatalha,
      uidStreamerApoiar: batalha?.idA
    });

    if (resposta.data?.sucesso) {
      const { doc: fDoc, setDoc: fSetDoc, serverTimestamp: fTimestamp } = await import('firebase/firestore');

      // CORRIGIDO: Sincronizado para bater exatamente com a rota que o teu SENSOR do useEffect escuta!
      const docClaqueARef = fDoc(db, "utilizadores", batalha.idA, "claque_batalhas_membros", meuUidLogado);
      await fSetDoc(docClaqueARef, {
        uid: meuUidLogado,
        nome: auth.currentUser?.displayName || "Adepto",
        foto: auth.currentUser?.photoURL || "",
        ativo: true,
        criadoEm: fTimestamp()
      });

            // ========================================================
        // XP AUTOMÁTICO - ABONO CLAQUE A (ARENA PK)
        // ========================================================
        if (meuUidLogado) {
          adicionarXP(meuUidLogado, 'adepto', 100);
        }
        if (batalha?.idA && batalha.idA !== meuUidLogado) {
          adicionarXP(batalha.idA, 'jogador', 100);
        }
        // ========================================================

      setEuPertencoAClaqueA(true);
      alert(`Bem-vindo à Claque Oficial de ${nomeDinamicoA}! 📣 Lugar de Estádio garantido.`);
    }
  } catch (err) {
    console.error("Erro ao aderir à claque A:", err);
    alert(err.message || "Erro ao processar a claque. Tenta novamente.");
  }
};

// ===========================================================================
// 🔵 ADESÃO À CLAQUE DO STREAMER B (CORRIGIDO E SINCRONIZADO VISUALMENTE)
// ===========================================================================
const comprarAbonoClaqueB = async () => {
  if (!batalha?.idB || !auth.currentUser?.uid) return;
  const meuUidLogado = auth.currentUser.uid;
  const nomeDinamicoB = batalha.nomeB || "Streamer";

  try {
    const { httpsCallable, getFunctions } = await import('firebase/functions');
    const fFunctions = getFunctions(undefined, 'europe-west1');

    const chamarClaqueServidor = httpsCallable(fFunctions, 'processarClaqueArenaSegura');
    const resposta = await chamarClaqueServidor({
      idBatalha: idBatalha,
      uidStreamerApoiar: batalha?.idB
    });

    if (resposta.data?.sucesso) {
      const { doc: fDoc, setDoc: fSetDoc, serverTimestamp: fTimestamp } = await import('firebase/firestore');

      // CORRIGIDO: Sincronizado para bater exatamente com a rota que o teu SENSOR do useEffect escuta!
      const docClaqueBRef = fDoc(db, "utilizadores", batalha.idB, "claque_batalhas_membros", meuUidLogado);
      await fSetDoc(docClaqueBRef, {
        uid: meuUidLogado,
        nome: auth.currentUser?.displayName || "Adepto",
        foto: auth.currentUser?.photoURL || "",
        ativo: true,
        criadoEm: fTimestamp()
      });

              // ========================================================
        // XP AUTOMÁTICO - ABONO CLAQUE B (ARENA PK)
        // ========================================================
        if (meuUidLogado) {
          adicionarXP(meuUidLogado, 'adepto', 100);
        }
        if (batalha?.idB && batalha.idB !== meuUidLogado) {
          adicionarXP(batalha.idB, 'jogador', 100);
        }
        // ========================================================

      setEuPertencoAClaqueB(true);
      alert(`Bem-vindo à Claque Oficial de ${nomeDinamicoB}! 📣 Lugar de Estádio garantido.`);
    }
  } catch (err) {
    console.error("Erro ao aderir à claque B:", err);
    alert(err.message || "Erro ao processar a claque. Tenta novamente.");
  }
};
  
    const processarTapTapArena = async (e) => {
    if (e) e.stopPropagation();
    
    const cliquesNovos = (window.acumuladorTapsArena || 0) + 1;
    window.acumuladorTapsArena = cliquesNovos;

    if (window.acumuladorTapsArena >= 10) {
      window.acumuladorTapsArena = 0;
      try {
        if (idBatalha) {
          await updateDoc(doc(db, "batalhasAtivas", idBatalha), {
            totalTapTaps: increment(10)
          });
        }
      } catch (erroTap) {
        console.error("Erro ao computar rajada de Tap Tap na Arena:", erroTap);
      }
    }
  };

  const avisoAtualizacaoEstadio = null;

  if (!batalha) return (
    <>
      {avisoAtualizacaoEstadio}
      <div style={{color:'white', textAlign:'center', marginTop:'50px'}}>Entrando no Estádio...</div>
    </>
  );

  const souOJogadorA = auth.currentUser.uid === batalha.idA;

  // MAPA DE JOGADORES: a esquerda é SEMPRE o anfitrião (idA) e a direita é
  // SEMPRE o adversário (idB), para jogadores e espetadores. Nome, foto, golos,
  // pontos, claque e janela de vídeo saem todos daqui, por isso não há maneira
  // de o nome de um aparecer por baixo da câmara do outro.
  //
  // Antes isto era escolhido por perspetiva (`souOJogadorA ? ... : ...`) e o
  // vídeo era colocado pelo uid do Agora: duas regras diferentes que davam
  // resultados opostos a quem estava a assistir.
  const mapaJogadores = construirMapaJogadores(batalha);
  const jogadorEsq = mapaJogadores.anfitriao;
  const jogadorDir = mapaJogadores.adversario;

  const golosEsq = jogadorEsq.golos;
  const golosDir = jogadorDir.golos;

  const ptsEsq = jogadorEsq.pontos;
  const ptsDir = jogadorDir.pontos;
  const total = ptsEsq + ptsDir;
  const percEsq = total === 0 ? 50 : (ptsEsq / total) * 100;
  const tempoVisual = Math.max(0, Number(batalha.tempo) || 0); // nunca "-1:-1"
  const souEspetador = auth.currentUser && auth.currentUser.uid !== batalha.idA && auth.currentUser.uid !== batalha.idB;

    // LÓGICA DE VITÓRIA / DERROTA BASEADA EM GOLOS REAIS E DESEMPATE POR PONTOS DA BARRA (CORRIGIDA)
  let resultadoEsq = "";
  let resultadoDir = "";

  if (batalha?.fase === "FIM") {
    const gEsq = golosEsq || 0;
    const gDir = golosDir || 0;
    
    // 💡 CORREÇÃO: Usar os pontos reais e validados do mapa (ptsEsq e ptsDir) que alimentam a tua barra visual
    const pEsq = ptsEsq || 0;
    const pDir = ptsDir || 0;

    if (gEsq > gDir) {
      resultadoEsq = "VITÓRIA";
      resultadoDir = "DERROTA";
    } else if (gDir > gEsq) {
      resultadoEsq = "DERROTA";
      resultadoDir = "VITÓRIA";
    } else {
      // CRITÉRIO DE DESEMPATE SEGURO: Se os golos forem iguais (0-0), desempatamos pelos pontos das barras!
      if (pEsq > pDir) {
        resultadoEsq = "VITÓRIA";
        resultadoDir = "DERROTA";
      } else if (pDir > pEsq) {
        resultadoEsq = "DERROTA";
        resultadoDir = "VITÓRIA";
      } else {
        // Se empatar em golos e em pontos exatos ao mesmo tempo, aí sim é empate real
        resultadoEsq = "EMPATE";
        resultadoDir = "EMPATE";
      }
    }
  }

  return (
  <div className="ecra-pk" style={{ backgroundImage: `url(${imgFundoVideo})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: '100vw', height: '100vh', color: '#fff', position: 'relative', overflow: 'hidden' }}>

                  {/* ========================================================================= */}
        {/* 🏟️ INTEGRANTE VISUAL DE LUCKYS DA ARENA PK: COMPONENTES 12 E 14           */}
        {/* ========================================================================= */}

                {/* 🏟️ FEED VIP DE COMBOS E LUCKYS EM TEMPO REAL (MOVIDO PARA A LINHA LARANJA) */}
        {listaAvisosFeed.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '370px', // 🟢 Cravado dinamicamente logo abaixo da barra bicolor para não tapar os streamers!
            left: '15px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            zIndex: 110000,
            pointerEvents: 'none',
            maxWidth: '85vw'
          }}>

            {listaAvisosFeed.map((card) => {
              const ganhouGrande = card.multiplicadorGanho > 1;

              return (
                <div 
                  key={card.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'transparent', // Totalmente limpo sem caixas gigantes
                    gap: '10px',
                    animation: 'fadeInLeft 0.2s ease-out'
                  }}
                >
                  {/* Foto de Perfil de quem envia */}
                  <img 
                    src={card.fotoRemetente || '/hero.png'} 
                    alt="perfil" 
                    style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1.5px solid #FFD700', objectFit: 'cover', boxShadow: '0 2px 8px rgba(0,0,0,0.5)' }} 
                  />

                  {/* Bloco Central de Textos com Sombra para Máxima Legibilidade */}
                  <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2', textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
                    <span style={{ color: '#FFF', fontSize: '13px', fontWeight: 'bold' }}>{card.nomeRemetente}</span>
                    <span style={{ color: '#ccc', fontSize: '10px', fontWeight: '500' }}>Enviar ➡️ {card.nomeDestinatario}</span>
                    
                    {/* Linha de pontuação que muda de cor e pisca se ganhar prémio grande! */}
                    <span style={{ 
                      color: ganhouGrande ? '#39FF14' : '#FFD700', 
                      fontSize: '11px', 
                      fontWeight: '900',
                      animation: ganhouGrande ? 'pulse 0.5s infinite alternate' : 'none',
                      textShadow: ganhouGrande ? '0 0 5px #39FF14' : '1px 1px 2px rgba(0,0,0,0.9)'
                    }}>
                      {(() => {
                        // 1. Se for Lucky, mantém a tua lógica VIP intacta
                        if (card.isLucky) {
                          return ` Bateu ${card.multiplicadorGanho}X! Ganho Total: ${card.totalGanhoBolas} ⚽ `;
                        }
                        // 2. Se o ícone contiver a palavra "gift", veio dos presentes de vídeo -> Caixinha!
                        if (card.presenteIcone && card.presenteIcone.toLowerCase().includes('gift')) {
                          return ` Enviou ${card.presenteNome} 🎁 `;
                        }
                        // 3. Se não for nenhum dos dois, veio da lista comum -> Trevo!
                        return ` Enviou ${card.presenteNome} 🍀 `;
                      })()}
                    </span>
                  </div>

                  {/* Ícone do Presente Pequeno */}
                  {card.presenteIcone && (
                    <img 
                      src={card.presenteIcone} 
                      alt="item" 
                      style={{ width: '26px', height: '26px', objectFit: 'contain', marginLeft: '5px', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }} 
                    />
                  )}

                  {/* 🎯 Alinhamento Supremo: Se o remetente for eu, lê o estado atómico síncrono da contagem para mexer na mesma frame da bolinha */}
                  <span style={{
                    color: '#FFF',
                    fontSize: '22px',
                    fontWeight: '950',
                    fontFamily: 'system-ui, sans-serif',
                    fontStyle: 'italic',
                    marginLeft: '6px',
                    textShadow: '2px 2px 4px #000, 0 0 8px rgba(255,255,255,0.2)'
                  }}>
                    x{card.uidRemetente === (auth.currentUser?.uid) ? contagemComboCliques : card.quantidadeCombo}
                  </span>
                </div>
              );
            })}
          </div>
        )}

            {/* ⚡ MODAL PREMIUM: LUCKYS MANTIDO TOTALMENTE INTACTO COM AS TUAS TRANCAS - CORREÇÃO DE LARGURA */}
      {mostrarMenuLuckys && (
        <div style={{ 
          position: 'fixed', 
          inset: 0, 
          backgroundColor: 'rgba(0,0,0,0.75)', 
          zIndex: 115000, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <div style={{ 
            position: 'relative',
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            padding: '16px', 
            borderRadius: '25px', 
            border: '2px solid #FFD700', 
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.6), 0 0 25px rgba(255, 215, 0, 0.25)', 
            width: '92%', 
            maxWidth: '410px', 
            boxSizing: 'border-box'
          }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <h3 style={{ color: '#FFD700', margin: 0, fontWeight: '900', fontSize: '14px', letterSpacing: '1px', textTransform: 'uppercase', textShadow: '0 0 10px rgba(255, 215, 0, 0.4)' }}>LUCKYS ARENA ⚡</h3>
                {/* Botão de interrogação regulamentar para aprovação imediata nas lojas */}
                <button 
                  onClick={() => {
                    const elemRegras = document.getElementById("subModalRegrasLuckysSala");
                    if (elemRegras) elemRegras.style.display = "block";
                  }} 
                  style={{ background: 'none', border: 'none', fontSize: '15px', cursor: 'pointer', padding: '0 4px', display: 'flex', alignItems: 'center' }}
                  title="Ver Regras de Probabilidade"
                >
                  ❓
                </button>
              </div>
              <button onClick={() => setMostrarMenuLuckys(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFD700', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}>✕</button>
            </div>

            {/* GAVETA INTERNA DE REGRAS MANDATÓRIAS EM PORTUGUÊS CONTRA REJEIÇÕES */}
            <div id="subModalRegrasLuckysSala" style={{ display: 'none', position: 'absolute', inset: 0, backgroundColor: 'rgba(10,15,20,0.98)', zIndex: 116000, padding: '16px', borderRadius: '25px', color: '#fff', textAlign: 'left', overflowY: 'auto', boxSizing: 'border-box', border: '2px solid #FFD700' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '6px' }}>
                <h4 style={{ margin: 0, color: '#FFD700', fontSize: '12px', fontWeight: '900' }}>🎡 REGRAS DO PRESENTE DA SORTE</h4>
                <button onClick={() => { const el = document.getElementById("subModalRegrasLuckysSala"); if (el) el.style.display = "none"; }} style={{ background: '#FFD700', border: 'none', borderRadius: '6px', padding: '2px 8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '10px', color: '#000' }}>FECHAR</button>
              </div>
              <div style={{ fontSize: '11px', lineHeight: '1.4', display: 'flex', flexDirection: 'column', gap: '8px', color: '#e0e0e0' }}>
                <p><strong>1. Funcionamento:</strong> O utilizador adquire e envia Presentes da Sorte através do seu saldo de Bolas, obtendo uma probabilidade aleatória de reaver recompensas com valores multiplicados.</p>
                <p><strong>2. Saldo Líquido Imediato:</strong> Todas as recompensas ganhas entram instantaneamente como saldo real na sua carteira, ficando 100% livres e disponíveis para levantamento imediato via transferência bancária, sem bloqueios ou trocas burocráticas.</p>
                <p><strong>3. Probabilidades Regulares:</strong><br />
                  Perder (0x): 60.89% | Retorno (1x): 22.00% | Dobro (2x): 11.50% | 5x: 3.00% | 10x: 2.00% | 20x: 0.50% | 50x: 0.10% | 100x: 0.01%.<br />
                  <span style={{ color: '#888' }}>(RTP Geral Estável: 96%).</span>
                </p>
                <p><strong>4. Canal de Caça-Jackpot 1000X (Apito e Capitão):</strong><br />
                  Perder (0x): 99.904% | Prémio Supremo (1000x): 0.096%.<br />
                  <span style={{ color: '#888' }}>(RTP Geral Estável: 96%).</span>
                </p>
              </div>
            </div>

                        {/* 🟢 SELETOR DINÂMICO DE STREAMER PARA OS LUCKYS (RESOLVE O BLOQUEIO) */}
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', padding: '0 8px' }}>
              <button
                type="button"
                onClick={() => setAlvoPresentePK('A')}
                style={{ flex: 1, padding: '8px', borderRadius: '10px', border: alvoPresentePK === 'A' ? '2px solid #ff4444' : '1px solid #333', background: alvoPresentePK === 'A' ? 'rgba(255,68,68,0.15)' : '#111', color: '#ff4444', fontWeight: '900', fontSize: '11px', cursor: 'pointer', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              >
                🟥 {batalha?.nomeA || "Jogador A"}
              </button>
              <button
                type="button"
                onClick={() => setAlvoPresentePK('B')}
                style={{ flex: 1, padding: '8px', borderRadius: '10px', border: alvoPresentePK === 'B' ? '2px solid #4444ff' : '1px solid #333', background: alvoPresentePK === 'B' ? 'rgba(68,68,255,0.15)' : '#111', color: '#6e6eff', fontWeight: '900', fontSize: '11px', cursor: 'pointer', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              >
                🟦 {batalha?.nomeB || "Jogador B"}
              </button>
            </div>

            <div className="presentes-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px', padding: '0 8px', height: '260px', maxHeight: '260px', overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', boxSizing: 'border-box' }}>
              {LISTA_LUCKYS.map((pres) => {
                const estaSelecionado = presenteSelecionado?.id === pres.id;
                return (
                  <div 
                    key={pres.id} 
                    onClick={() => {
                      setPresenteSelecionado(pres); 
                      setUltimoLuckyEnviado(pres); 
                    }}
                    style={{ 
                      textAlign: 'center', 
                      cursor: 'pointer', 
                      padding: '6px 4px', 
                      background: estaSelecionado ? 'rgba(255, 215, 0, 0.1)' : 'rgba(255, 255, 255, 0.03)', 
                      border: estaSelecionado ? '2px solid #FFD700' : '1px solid rgba(255, 255, 255, 0.06)', 
                      boxShadow: estaSelecionado ? '0 0 10px rgba(255, 215, 0, 0.3)' : 'none',
                      borderRadius: '12px', 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      transition: 'all 0.2s ease',
                      boxSizing: 'border-box'
                    }}
                  >
                    <div style={{ width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px' }}>
                      <img src={pres.icone} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} alt={pres.nome} loading="lazy" />
                    </div>
                    <p style={{ color: '#FFF', fontSize: '8px', fontWeight: 'bold', margin: '0 0 2px 0', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.1', textTransform: 'uppercase', width: '100%' }}>{pres.nome}</p>
                    <p style={{ color: '#FFD700', fontSize: '9px', fontWeight: '900', margin: 0, fontFamily: 'monospace' }}>⚽ {pres.preco}</p>
                  </div>
                );
              })}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <select value={quantidadeSelecionada} onChange={(e) => setQuantidadeSelecionada(Number(e.target.value))} style={{ backgroundColor: 'rgba(0,0,0,0.5)', color: '#FFD700', border: '1px solid #FFD700', padding: '6px 24px 6px 12px', borderRadius: '12px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', appearance: 'none', outline: 'none' }}>
                  <option value={1}>1</option>
                  <option value={10}>10</option>
                  <option value={99}>99</option>
                  <option value={188}>188</option>
                  <option value={999}>999</option>
                  <option value={1888}>1888</option>
                  <option value={2999}>2999</option>
                </select>
                <span style={{ color: '#FFD700', fontSize: '10px', position: 'absolute', right: '10px', pointerEvents: 'none' }}>▼</span>
              </div>

              <button 
                onClick={() => { 
                  if (!presenteSelecionado || presenteSelecionado.tipo !== 'lucky') { 
                    alert("Por favor, seleciona primeiro um item Lucky!"); 
                    return; 
                  } 
                  
                  // Deteta cirurgicamente o alvo ativo selecionado na Arena PK (Lado Esquerdo A ou Direito B)
                  const streamAlvoUid = (alvoPresentePK === 'A' ? batalha?.idA : batalha?.idB) || batalha?.idA || idA;
                  const streamAlvoNome = alvoPresentePK === 'A' ? (batalha?.nomeA || "Jogador A") : (batalha?.nomeB || "Jogador B");

                  processarEnvioPresente(
                    { ...presenteSelecionado, quantidade: quantidadeSelecionada || 1 }, 
                    { uid: streamAlvoUid, nome: streamAlvoNome }
                  );

                  setMostrarMenuLuckys(false); 
                }} 
                style={{ backgroundColor: '#00B359', color: 'white', border: 'none', padding: '8px 24px', borderRadius: '12px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0, 179, 89, 0.3)' }}
              >
                Enviar
              </button>
            </div>

          </div>
        </div>
      )}

      {avisoAtualizacaoEstadio}
      
      {/* PLACAR DINÂMICO CRESCENDO COM GOLOS REAIS */}
      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '15px', alignItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: '900', fontSize: '32px', color: '#ff4444' }}>{golosEsq}</div>
          <div style={{ fontSize: '10px' }}>{jogadorEsq.nome}</div>
        </div>
        <div style={{ background: '#39FF14', color: 'black', padding: '5px 15px', borderRadius: '20px', fontWeight: '900' }}>
          {batalha.fase === "INTERVALO" ? "INT" : formatarTempo(tempoVisual)}
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: '900', fontSize: '32px', color: '#4444ff' }}>{golosDir}</div>
          <div style={{ fontSize: '10px' }}>{jogadorDir.nome}</div>
        </div>
      </div>

      <div style={{ width: '94%', height: '32px', backgroundColor: '#222', margin: '0 auto', borderRadius: '8px', overflow: 'hidden', display: 'flex', position: 'relative', border: '2px solid #333' }}>
        <div style={{ width: `${percEsq}%`, backgroundColor: '#ff4444', transition: 'width 0.5s' }} />
        <div style={{ width: `${100 - percEsq}%`, backgroundColor: '#4444ff', transition: 'width 0.5s' }} />
        <div style={{ position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 15px', fontWeight: 'bold', fontSize: '13px', boxSizing: 'border-box', pointerEvents: 'none' }}>
          <span>{ptsEsq} Pts</span>
          <span>{ptsDir} Pts</span>
        </div>
      </div>

          {/* PAINEL CENTRAL DE CONTADORES E CLAQUES ALFA (INVERSÃO DE LAYOUT E SIMETRIA TOTAL) */}
      {(() => {
        // Ligado ao slot, não à perspetiva: a claque da esquerda é a do
        // anfitrião para toda a gente que está a ver.
        const pertenceEsq = euPertencoAClaqueA;
        const pertenceDir = euPertencoAClaqueB;

        const ativosEsq = totalMembrosClaqueA;
        const ativosDir = totalMembrosClaqueB;

        const acaoEsq = comprarAbonoClaqueA;
        const acaoDir = comprarAbonoClaqueB;

        const processarCliqueEsq = () => {
          if (!souEspetador) {
            alert("Os streamers em campo não podem comprar bilhetes de claque! ⚽");
            return;
          }
          if (pertenceEsq) {
            alert("Já pertences a esta Claque Oficial! 📣");
            return;
          }
          acaoEsq();
        };

        const processarCliqueDir = () => {
          if (!souEspetador) {
            alert("Os streamers em campo não podem comprar bilhetes de claque! ⚽");
            return;
          }
          if (pertenceDir) {
            alert("Já pertences a esta Claque Oficial! 📣");
            return;
          }
          acaoDir();
        };

        return (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', width: '94%', margin: '8px auto 0 auto', zIndex: 10, boxSizing: 'border-box' }}>
            
            {/* CLAQUE DO JOGADOR DA ESQUERDA (VERMELHO) */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', maxWidth: '35%' }}>
              <button
                onClick={processarCliqueEsq}
                style={{ 
                  background: 'rgba(0,0,0,0.6)', 
                  padding: '4px 8px', 
                  borderRadius: '15px', 
                  border: pertenceEsq ? '1px solid #39FF14' : '1px solid #00E5FF', // Borda verde se for membro, ciano se puder comprar
                  boxShadow: pertenceEsq ? '0 0 6px rgba(57, 255, 20, 0.25)' : '0 0 6px rgba(0, 229, 255, 0.25)', 
                  height: '24px', 
                  boxSizing: 'border-box', 
                  color: pertenceEsq ? '#39FF14' : '#00E5FF', 
                  fontSize: '8px', 
                  fontWeight: '900', 
                  whiteSpace: 'nowrap', 
                  cursor: 'pointer', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  width: '100%' 
                }}
              >
                {pertenceEsq ? "📣 CLAQUE MEMBRO (100 ⚽)" : "📣 CLAQUE (100 ⚽)"}
              </button>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <span style={{ fontSize: '10px', filter: pertenceEsq ? 'drop-shadow(0 0 3px #39FF14)' : 'drop-shadow(0 0 3px #00E5FF)' }}>👥</span>
                <span style={{ color: pertenceEsq ? '#39FF14' : '#00E5FF', fontSize: '11px', fontWeight: '900', fontFamily: 'monospace', textShadow: pertenceEsq ? '0 0 5px #39FF14' : '0 0 5px #00E5FF' }}>
                  {ativosEsq} ativos
                </span>
              </div>
            </div>

            {/* COLUNA CENTRAL FIXA (OLHINHO E SINAL DE RECOMPENSA DE CLIQUES) */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', minWidth: '25%' }}>
              <div onClick={() => setMostrarListaEspectadores(true)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', height: '24px' }}>
                <span style={{ fontSize: '14px', filter: 'drop-shadow(0 0 5px #39FF14)' }}>👁️</span>
                <span style={{ color: '#39FF14', fontSize: '15px', fontWeight: '900', fontFamily: 'monospace', textShadow: '0 0 8px #39FF14' }}>
                  {totalGente}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span style={{ fontSize: '12px', filter: 'drop-shadow(0 0 4px #FF007F)' }}>🔥</span>
                <span style={{ color: '#FF007F', fontSize: '13px', fontWeight: '900', fontFamily: 'monospace', textShadow: '0 0 6px #FF007F' }}>
                  {totalTapTapsArena}
                </span>
              </div>
            </div>

            {/* CLAQUE DO JOGADOR DA DIREITA (AZUL) */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', maxWidth: '35%' }}>
              <button
                onClick={processarCliqueDir}
                style={{ 
                  background: 'rgba(0,0,0,0.6)', 
                  padding: '4px 8px', 
                  borderRadius: '15px', 
                  border: pertenceDir ? '1px solid #39FF14' : '1px solid #00E5FF', 
                  boxShadow: pertenceDir ? '0 0 6px rgba(57, 255, 20, 0.25)' : '0 0 6px rgba(0, 229, 255, 0.25)', 
                  height: '24px', 
                  boxSizing: 'border-box', 
                  color: pertenceDir ? '#39FF14' : '#00E5FF', 
                  fontSize: '8px', 
                  fontWeight: '900', 
                  whiteSpace: 'nowrap', 
                  cursor: 'pointer', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  width: '100%' 
                }}
              >
                {pertenceDir ? "📣 CLAQUE MEMBRO (100 ⚽)" : "📣 CLAQUE (100 ⚽)"}
              </button>
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <span style={{ fontSize: '10px', filter: pertenceDir ? 'drop-shadow(0 0 3px #39FF14)' : 'drop-shadow(0 0 3px #00E5FF)' }}>👥</span>
                <span style={{ color: pertenceDir ? '#39FF14' : '#00E5FF', fontSize: '11px', fontWeight: '900', fontFamily: 'monospace', textShadow: pertenceDir ? '0 0 5px #39FF14' : '0 0 5px #00E5FF' }}>
                  {ativosDir} ativos
                </span>
              </div>
            </div>

          </div>
        );
      })()}

                  <div style={{ display: 'flex', flexDirection: 'row', width: '94%', height: '28vh', minHeight: '28vh', margin: '10px auto 0 auto', gap: '6px', position: 'relative', flexShrink: 0, marginBottom: '35px' }}>

        {/* A ENTRAR / ERRO DE LIGAÇÃO — por cima das duas janelas de vídeo */}
        <EstadoLigacaoEstadio
          estado={ligacao.estado}
          mensagemErro={ligacao.mensagemErro}
          aoTentarDeNovo={ligacao.tentarDeNovo}
          aoSair={typeof aoSair === 'function' ? aoSair : undefined}
        />

                                <div id="janela-local" className="janela-video" style={{ width: '50%', height: '100%', backgroundColor: '#111', borderRadius: '12px', position: 'relative', overflow: 'hidden', backgroundImage: jogadorEsq.foto ? `url(${jogadorEsq.foto})` : 'none', backgroundSize: 'cover', backgroundPosition: 'center' }}>

                                {/* SÓ a câmara entra aqui (ver agoraSession.js); a barra de BOLAS e o resto ficam. */}
                          <div className="ecra-camara" />
                {/* MARQUEE DE BOLAS EM PLAY CORRIDO - JOGADOR DA ESQUERDA (VERMELHO) */}
          {(() => {
            const moedasEsq = Number(moedasStreamerA);

            return (
              <div style={{ 
  position: 'absolute',
  bottom: '-5px',
  left: '4px', 
  right: '4px', 
  backgroundColor: '#ff4444', 
  borderRadius: '25px', 
  height: '22px', 
  display: 'flex', 
  alignItems: 'center', 
  overflow: 'hidden',
  boxShadow: '0 0 10px rgba(255, 68, 68, 0.6)',
  zIndex: 9999
}}>
                <marquee behavior="scroll" direction="left" scrollamount="3" style={{ color: '#FFFFFF', fontSize: '9px', fontWeight: '900', fontFamily: 'monospace', width: '100%', margin: 0, padding: '0 6px' }}>
                                          PONTUAÇÃO DA LIVE: {moedasEsq.toLocaleString()} BOLAS ⚽&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </marquee>
              </div>
            );
          })()}
        </div>

        {/* 📣 MOTOR DE ANIMAÇÃO DE STICKERS CENTRALIZADO SUPREMO (MEIO DO ECRÃ - AMBOS OS LADOS) */}
    {stickerAtivo && (
      <div style={{ 
        position: 'absolute', 
        top: '40%', // Centralizado verticalmente em cima das janelas de vídeo
        left: '50%', 
        transform: 'translate(-50%, -50%)', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        backgroundColor: 'rgba(0,0,0,0.85)', 
        padding: '15px 25px', 
        borderRadius: '25px', 
        border: stickerAtivo.campoStreamer === 'A' ? '2px solid #ff4444' : '2px solid #4444ff', 
        zIndex: 120000, 
        animation: 'zoomIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        boxShadow: '0 0 25px rgba(0,0,0,0.7)'
      }}>
        <img src={stickerAtivo.icone} alt={stickerAtivo.nome} style={{ width: '70px', height: '70px', objectFit: 'contain' }} />
        <span style={{ fontSize: '13px', fontWeight: '900', color: '#FFD700', marginTop: '6px', textTransform: 'uppercase', textShadow: '0 2px 4px #000' }}>
          {stickerAtivo.nome}!
        </span>
        <span style={{ fontSize: '10px', color: '#FFF', fontWeight: '500' }}>
          Enviado para {stickerAtivo.campoStreamer === 'A' ? (batalha?.nomeA || "Jogador Esquerda") : (batalha?.nomeB || "Jogador Direita")} 📣
        </span>
      </div>
    )}

    {/* JANELA DO RIVAL (LADO DIREITO - AZUL) */}
    <div id="janela-rival" className="janela-video" style={{ width: '50%', height: '100%', backgroundColor: '#111', borderRadius: '12px', position: 'relative', overflow: 'hidden', backgroundImage: jogadorDir.foto ? `url(${jogadorDir.foto})` : 'none', backgroundSize: 'cover', backgroundPosition: 'center' }}>
      {/* SÓ a câmara entra aqui (ver agoraSession.js); a barra de BOLAS fica intacta. */}
      <div className="ecra-camara" />
      
      {/* MARQUEE DE BOLAS EM PLAY CORRIDO - JOGADOR DA DIREITA (AZUL) */}
      {(() => {
        const moedasDir = Number(moedasStreamerB);
        return (
          <div style={{ 
            position: 'absolute',
            bottom: '-5px',
            left: '4px', 
            right: '4px', 
            backgroundColor: '#4444ff', 
            borderRadius: '25px', 
            height: '22px', 
            display: 'flex', 
            alignItems: 'center', 
            overflow: 'hidden',
            boxShadow: '0 0 10px rgba(68, 68, 255, 0.6)',
            zIndex: 9999
          }}>
            <marquee behavior="scroll" direction="left" scrollamount="3" style={{ color: '#FFFFFF', fontSize: '9px', fontWeight: '900', fontFamily: 'monospace', width: '100%', margin: 0, padding: '0 6px' }}>
              PONTUATION DA LIVE: {moedasDir.toLocaleString()} BOLAS ⚽&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </marquee>
          </div>
        );
      })()}
    </div>

       {mensagemJuiz && (
          <div style={{ position: 'absolute', width: '100%', top: '40%', textAlign: 'center', color: '#39FF14', fontSize: '26px', fontWeight: '900', textShadow: '0 0 10px black' }}>
            {mensagemJuiz}
          </div>
        )}

                        {/* OPÇÕES FINAIS EXCLUSIVAS POR FUNÇÃO (ESTILO TIKTOK) */}
        {mostrarOpcoesFim && !souEspetador && (
          <div style={{ position: 'absolute', width: '100%', top: '50%', transform: 'translateY(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', zIndex: 30 }}>
            {souOJogadorA ? (
              /* SE FOR O CRIADOR (MIGUEL): MOSTRA OS BOTÕES DE COMANDO */
              <>
                <button 
                  onClick={reiniciarBatalha}
                  style={{ background: '#39FF14', color: 'black', border: 'none', padding: '15px 35px', borderRadius: '30px', fontWeight: '900', fontSize: '18px', boxShadow: '0 0 15px #39FF14', cursor: 'pointer' }}
                >
                  NOVO JOGO ⚽
                </button>
                <button
                  onClick={() => setMostrarBuscaRivalRapida(true)}
                  style={{ background: 'none', color: '#39FF14', border: '2px solid #39FF14', padding: '10px 25px', borderRadius: '30px', fontWeight: '900', fontSize: '13px', cursor: 'pointer', boxShadow: '0 0 10px rgba(57, 255, 20, 0.2)' }}
                >
                  PROCURAR RIVAL 🔄
                </button>
              </>
            ) : (
              /* SE FOR O RIVAL (MÁRCIA): APENAS ASSISTE E AGUARDA EM CAMPO */
              <div style={{ 
                background: 'rgba(0, 0, 0, 0.85)', 
                color: '#39FF14', 
                padding: '15px 25px', 
                borderRadius: '20px', 
                fontWeight: '900', 
                fontSize: '15px', 
                border: '2px solid #39FF14',
                textShadow: '0 0 10px black',
                boxShadow: '0 0 15px rgba(57, 255, 20, 0.3)',
                textAlign: 'center'
              }}>
                ⚽ AGUARDANDO REVANCHE... <br/>
                <span style={{ fontSize: '11px', color: '#aaa', fontWeight: 'normal' }}>O criador está a reiniciar a partida</span>
              </div>
            )}
          </div>
        )}

              {/* ETIQUETAS DE RESULTADO FINAL CORRIGIDAS (DESEMPATE REAL POR PONTOS) */}
        {mostrarResultadoFinal && (
          <>
            {resultadoEsq === "EMPATE" ? (
              /* SÓ DÁ EMPATE SE EMPATAR EM GOLOS E EM PONTOS EXATOS AO MESMO TEMPO */
              <div style={{ position: 'absolute', left: '50%', top: '40%', transform: 'translate(-50%, -50%)', color: '#ffcc00', fontSize: '40px', fontWeight: '900', textShadow: '0 0 20px black', zIndex: 20, whiteSpace: 'nowrap' }}>
                EMPATE 🤝
              </div>
            ) : (
              /* SE HOUVER VENCEDOR (POR GOLOS OU POR PONTOS), MOSTRA VITÓRIA/DERROTA NOS LADOS CORRETOS */
              <>
                <div style={{ position: 'absolute', left: '25%', top: '40%', transform: 'translate(-50%, -50%)', color: resultadoEsq === "VITÓRIA" ? "#39FF14" : "#ff4444", fontSize: '30px', fontWeight: '900', textShadow: '0 0 15px black', zIndex: 20 }}>
                  {resultadoEsq}
                </div>
                <div style={{ position: 'absolute', left: '75%', top: '40%', transform: 'translate(-50%, -50%)', color: resultadoDir === "VITÓRIA" ? "#39FF14" : "#ff4444", fontSize: '30px', fontWeight: '900', textShadow: '0 0 15px black', zIndex: 20 }}>
                  {resultadoDir}
                </div>
              </>
            )}
          </>
        )}

      {/* MOTOR UNIFICADO DA ARENA: PRESENTES MP4 COM CHROMA KEY E SOM (SEM APAGÃO PRETO) */}
        {videoAtivo && (
          <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'transparent', // 🟢 Totalmente transparente para não tapar os lutadores
            pointerEvents: 'none'
          }}>
            {/* 💍 Presente com versão sem fundo (assets/presentes/transparentes):
                recorte feito por IA, cores do próprio presente intactas. */}
            {videoSemFundo(videoAtivo) ? (
              <PresenteTransparente
                key={videoAtivo}
                src={videoSemFundo(videoAtivo)}
                // Mantido a false para os vídeos não duplicarem som com a bomba
                comSom={false}
                aoTerminar={() => setVideoAtivo(null)}
                aoComecar={() => {
                  // 🔇 ÁUDIO DA BOMBA EXPULSO DAQUI PARA NÃO SUBREPOR O SOM NATIVO DO VÍDEO
                }}
              />
            ) : (
            <div style={{ position: 'relative', width: '300px', height: '300px' }}>
              {/* Canvas que tritura e remove o fundo VERDE em tempo real na batalha */}
              <canvas
                ref={(canvas) => {
                  if (!canvas) return;
                  const video = document.getElementById('video_player_arena_premium');
                  if (!video) return;
                  const ctx = canvas.getContext('2d');
                  let frameId;
                  
                  const limparVerde = () => {
                    if (video.paused || video.ended) return;
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const len = imgData.data.length;
                    
                    for (let i = 0; i < len; i += 4) {
                      const r = imgData.data[i];
                      const g = imgData.data[i+1];
                      const b = imgData.data[i+2];
                      
                      // Filtro Chroma Key idêntico ao das Lives para o verde do Kling AI
                      if (g > 55 && g > r * 1.15 && g > b * 1.15) {
                        imgData.data[i+3] = 0; // Torna o fundo 100% transparente
                      }
                    }
                    ctx.putImageData(imgData, 0, 0);
                    frameId = requestAnimationFrame(limparVerde);
                  };
                  
                  video.addEventListener('play', limparVerde);
                  return () => cancelAnimationFrame(frameId);
                }}
                width={480}
                height={480}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
                         {/* O vídeo corre nativamente com o seu próprio som original de estádio */}
            <video
              id="video_player_arena_premium"
              src={videoAtivo}
              autoPlay
              playsInline
              controls={false}
              style={{ display: 'none' }}
              onEnded={() => setVideoAtivo(null)} // Fecha o presente assim que terminar
              onError={() => setVideoAtivo(null)}
              ref={(videoEl) => {
                if (!videoEl) return;
                // 🟢 DESBLOQUEIO SUPREMO DE ÁUDIO NATIVO:
                videoEl.muted = false;
                videoEl.volume = 1.0;
                
                // Tenta forçar o play com som assim que a referência é criada
                videoEl.play().catch((errPlay) => {
                  console.log("Navegador bloqueou autoplay com som, a tentar reativar:", errPlay);
                });
              }}
            />
            </div>
            )}
          </div>
        )}

      </div>

      {/* CHAT DA BATALHA — POR BAIXO DAS CÂMARAS.
          Ocupa o espaço que sobra entre a linha de vídeo e a barra de baixo
          (flex: 1) e faz scroll cá dentro. O espaçador com marginTop: auto
          encosta as mensagens ao fundo enquanto são poucas; quando enchem, o
          scrollToBottom() (chamado a cada mensagem nova) mantém a última à
          vista — vão subindo conforme as pessoas escrevem. */}
        <div id="chat-batalha" style={{ flex: 1, width: '94%', overflowY: 'auto', maxHeight: '200px', scrollbarWidth: 'thin', WebkitOverflowScrolling: 'touch', display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '110px' }}>
        <div style={{ marginTop: 'auto' }} />
            
        {mensagensChat.map((msg) => {
        const idAutor = msg.uid;
        const fotoAutorChat = msg.foto || '/hero.png';
        return (
        <div key={msg.id} style={{ 
        fontSize: '13px', 
        color: '#fff', 
        background: 'rgba(0, 0, 0, 0.6)', 
        padding: '6px 12px', 
        borderRadius: '12px', 
        alignSelf: 'flex-start', 
        maxWidth: '90%',
        border: '1px solid rgba(57, 255, 20, 0.15)',
        boxShadow: '0 0 8px rgba(57, 255, 20, 0.05)',
        marginBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
        }}>
        {/* FOTO REDONDA ESTILO TIKTOK COM GATILHO DE PERFIL PREPARADO */}
        <img
          src={fotoAutorChat}
          onClick={() => { 
            if (idAutor) {
              // Alarme global: a raiz (ArenaPK) escuta e sobrepõe o perfil à batalha
              window.dispatchEvent(new CustomEvent('abrirPerfilUsuario', { detail: idAutor }));
            }
          }}
          alt="Perfil"
          style={{ width: '22px', height: '22px', borderRadius: '50%', border: '1.5px solid #39FF14', objectFit: 'cover', flexShrink: 0, cursor: idAutor ? 'pointer' : 'default' }}
          onError={(e) => { e.target.src = '/hero.png'; }}
        />
        
                        {/* CORNETA DINÂMICA: Aparece se o autor for membro da claque do Streamer A ou B */}
        {(() => {
          const ehSocioA = idsClaqueA?.includes(msg.uid);
          const ehSocioB = idsClaqueB?.includes(msg.uid);
          
          if (ehSocioA || ehSocioB) {
            return (
              <span 
                style={{ 
                  fontSize: '11px', 
                  filter: 'drop-shadow(0 0 3px #00E5FF)',
                  marginLeft: '2px',
                  marginRight: '2px',
                  cursor: 'default'
                }}
                title="Claque Oficial"
              >
                📣
              </span>
            );
          }
          return null;
        })()}
        
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
              
              {/* Crachá de Adepto (Rosa) + Texto do Nível */}
              {msg.nivelAdepto && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <img 
                    src={obterImagemAdepto(msg.nivelAdepto)} 
                    alt={`Adepto Lv ${msg.nivelAdepto}`} 
                    style={{ width: '16px', height: '16px', borderRadius: '50%', border: '1px solid #FF007F', boxShadow: '0 0 4px #FF007F', objectFit: 'cover' }} 
                  />
                  <span style={{ color: '#FF007F', fontSize: '9px', fontWeight: '900', textShadow: '0 0 3px #FF007F', fontFamily: 'sans-serif' }}>
                    Lv.{msg.nivelAdepto}
                  </span>
                </div>
              )}

              {/* Crachá de Jogador (Verde) + Texto do Nível */}
              {msg.nivelJogador && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <img 
                    src={obterImagemJogador(msg.nivelJogador)} 
                    alt={`Jogador Lv ${msg.nivelJogador}`} 
                    style={{ width: '16px', height: '16px', borderRadius: '50%', border: '1px solid #39FF14', boxShadow: '0 0 4px #39FF14', objectFit: 'cover' }} 
                  />
                  <span style={{ color: '#39FF14', fontSize: '9px', fontWeight: '900', textShadow: '0 0 3px #39FF14', fontFamily: 'sans-serif' }}>
                    Lv.{msg.nivelJogador}
                  </span>
                </div>
              )}

              <span
                onClick={() => {
                  if (idAutor) {
                    window.dispatchEvent(new CustomEvent('abrirPerfilUsuario', { detail: idAutor }));
                  }
                }}
                style={{ color: '#39FF14', fontWeight: 'bold', fontSize: '13px', cursor: idAutor ? 'pointer' : 'default' }}
              >
                {msg.nome || 'Adepto'}:
              </span>

              {/* VALIDAÇÃO CIRÚRGICA: Alerta VIP Destacado para Envio de Presentes */}
              {msg.tipo === "presente" || msg.texto?.includes("enviou") ? (
                <span style={{
                  color: '#FFD700',
                  fontSize: '13px',
                  fontWeight: '900',
                  textAlign: 'left',
                  background: 'rgba(255, 215, 0, 0.15)',
                  padding: '4px 10px',
                  borderRadius: '8px',
                  border: '1px dashed #FFD700',
                  boxShadow: '0 0 10px rgba(255, 215, 0, 0.3)',
                  display: 'inline-block',
                  marginTop: '2px',
                  fontStyle: 'italic',
                  textShadow: '0 0 4px #FFD700'
                }}>
                  🎁 {msg.texto}
                </span>
              ) : (
                /* TEXTO NORMAL DO CHAT (Conversas comuns) */
                <span style={{ color: '#ffffff', fontSize: '13px', textAlign: 'left' }}>
                  {msg.texto}
                </span>
              )}
            </div>

        </div>
        );
        })}
        
        <div ref={messagesEndRef} />
        </div>

      {/* GAVETA REAL DE PRESENTES DA ARENA: ESCOLHE O LUTADOR E DISPARA O MP4 */}
      {mostrarPresentesPK && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, backgroundColor: '#0d0d0d', borderTop: '2px solid #39FF14', borderTopLeftRadius: '20px', borderTopRightRadius: '20px', zIndex: 100002, padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', boxShadow: '0 -5px 25px rgba(0,0,0,0.8)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #222', paddingBottom: '8px' }}>
            <span style={{ fontSize: '13px', color: '#39FF14', fontWeight: '900' }}>ESCOLHE O PRESENTE ⚽</span>
            <button onClick={() => setMostrarPresentesPK(false)} style={{ backgroundColor: 'transparent', border: 'none', color: '#FFF', fontSize: '12px', cursor: 'pointer' }}>Fechar ✕</button>
          </div>

          {/* PARA QUEM VAI O PRESENTE: SELETOR DO LUTADOR (VERMELHO = A, AZUL = B) */}
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => setAlvoPresentePK('A')}
              style={{ flex: 1, padding: '8px', borderRadius: '10px', border: alvoPresentePK === 'A' ? '2px solid #ff4444' : '1px solid #333', background: alvoPresentePK === 'A' ? 'rgba(255,68,68,0.15)' : '#111', color: '#ff4444', fontWeight: '900', fontSize: '12px', cursor: 'pointer', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              🟥 {batalha.nomeA || "Jogador A"}
            </button>
            <button
              onClick={() => setAlvoPresentePK('B')}
              style={{ flex: 1, padding: '8px', borderRadius: '10px', border: alvoPresentePK === 'B' ? '2px solid #4444ff' : '1px solid #333', background: alvoPresentePK === 'B' ? 'rgba(68,68,255,0.15)' : '#111', color: '#6e6eff', fontWeight: '900', fontSize: '12px', cursor: 'pointer', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              🟦 {batalha.nomeB || "Jogador B"}
            </button>
          </div>

          {/* GRELHA 3x3 DOS PRESENTES REAIS COM SCROLL */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', maxHeight: '230px', overflowY: 'auto', padding: '4px 2px' }}>
            {LISTA_PRESENTES.map((pres) => (
              <div
                key={pres.id}
                onClick={async () => {
                  const receptorID = alvoPresentePK === 'A' ? batalha.idA : batalha.idB;
                  if (!receptorID) return;
                  await enviarPresente(pres, receptorID);
                  setMostrarPresentesPK(false);
                }}
                style={{ backgroundColor: '#161616', border: '1px solid #222', borderRadius: '12px', padding: '10px 6px', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', gap: '3px' }}
              >
                <img src={pres.icone} alt={pres.nome} style={{ width: '38px', height: '38px', objectFit: 'contain' }} />
                <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#FFF', textAlign: 'center' }}>{pres.nome}</span>
                <span style={{ fontSize: '9px', color: '#39FF14', fontWeight: 'bold' }}>🪙 {pres.preco}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 🟢 GAVETA REAL DE STICKERS DA CLAQUE COM UPGRADE DE CADERNETA E BLOQUEIO DE SEGURANÇA (CORRIGIDO) */}
{mostrarMenuStickers && (
  <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, backgroundColor: '#0d0d0d', borderTop: '2px solid #333', padding: '12px 16px', zIndex: 9999, borderTopLeftRadius: '20px', borderTopRightRadius: '20px', boxShadow: '0 -4px 20px rgba(0,0,0,0.8)' }}>
    
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
      <span style={{ fontSize: '13px', color: '#FFD700', fontWeight: '900' }}>
        {(!souEspetador) ? "📖 A MINHA CADERNETA (MODO LEITURA)" : "ESCOLHE O TEU STICKER DA CLAQUE"}
      </span>
      <button onClick={() => setMostrarMenuStickers(false)} style={{ backgroundColor: 'transparent', border: 'none', color: '#aaa', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}>✕</button>
    </div>

    {/* SELETOR DO LUTADOR: SÓ APARECE PARA ESPETADORES. STREAMERS FICAM TRANCADOS NA SUA PRÓPRIA GAVETA */}
    {souEspetador && (
      <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
        <button
          onClick={() => setAlvoStickerPK('A')}
          style={{ flex: 1, padding: '8px', borderRadius: '10px', border: alvoStickerPK === 'A' ? '2px solid #FF0000' : '1px solid #333', backgroundColor: alvoStickerPK === 'A' ? 'rgba(255,0,0,0.1)' : '#161616', color: '#FFF', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}
        >
          🟥 {batalha?.nomeA || "Jogador A"}
        </button>
        <button
          onClick={() => setAlvoStickerPK('B')}
          style={{ flex: 1, padding: '8px', borderRadius: '10px', border: alvoStickerPK === 'B' ? '2px solid #0000FF' : '1px solid #333', backgroundColor: alvoStickerPK === 'B' ? 'rgba(0,0,0,0.1)' : '#161616', color: '#FFF', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}
        >
          🟦 {batalha?.nomeB || "Jogador B"}
        </button>
      </div>
    )}

            {/* GRELHA DOS STICKERS COM SCROLL E DESIGN IDENTICO À LIVE SOLO */}
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', maxHeight: '230px', overflowY: 'auto', padding: '4px 2px' }}>
      {LISTA_STICKERS.map((stk) => {
        
        // 🎯 UNIFICAÇÃO DA CADERNETA: Passa o ID do cromo (ex: 101-150) para o ID puro da base de dados (ex: 1-50)
        const idStkNum = Number(stk.id);
        const idLimpoParaProcurar = String(idStkNum > 100 ? idStkNum - 100 : idStkNum);
        
        const jaAdquirido = idsStickersDoadosAlvo.some(id => String(id) === idLimpoParaProcurar);

        return (
          <div
            key={stk.id}
          
                      onClick={async () => {
              if (!souEspetador) {
                alert("Estás a consultar a tua caderneta. Apenas os espetadores podem preencher o teu álbum! 🏆");
                return;
              }

              const idStkNum = Number(stk.id);
              const idRealBaseDados = idStkNum > 100 ? (idStkNum - 100) : idStkNum;

              if (idsStickersDoadosAlvo.some(id => String(id) === String(idRealBaseDados))) {
                alert("Este sticker já foi doado para a caderneta deste streamer! Escolha outro cromo. ⚽");
                return;
              }

              const receptorID = alvoStickerPK === 'B' ? batalha?.idB : batalha?.idA;
              const receptorNome = alvoStickerPK === 'B' ? (batalha?.nomeB || "Streamer B") : (batalha?.nomeA || "Streamer A");
              const ladoAlvo = alvoStickerPK === 'B' ? "pontosB" : "pontosA";
              
              if (!receptorID) return;

              // 1. Força a atualização imediata da barra visual no Firebase para milhares de pessoas verem
              const { doc: fDoc, updateDoc: fUpdateDoc, increment: fIncrement } = await import('firebase/firestore');
              await fUpdateDoc(fDoc(db, "batalhasAtivas", idBatalha), {
                [ladoAlvo]: fIncrement(stk.preco)
              }).catch(() => {});

              // 2. Dispara o motor mestre que valida a carteira, processa o saldo e as comissões do Admin
              await processarEnvioPresente(
                { id: stk.id, preco: stk.preco, nome: stk.nome, tipo: 'sticker' },
                { uid: receptorID, nome: receptorNome }
              );

              // 3. Força o Radar Central a capturar a animação e explodir o cromo em ponto grande
              setStickerAtivo({
                ...stk,
                campoStreamer: alvoStickerPK === 'B' ? 'B' : 'A'
              });

              // Limpa a animação central após 3 segundos
              setTimeout(() => {
                setStickerAtivo(null);
              }, 3000);
              
              setMostrarMenuStickers(false);
            }}

            style={{ 
              backgroundColor: jaAdquirido ? 'rgba(57, 255, 20, 0.08)' : '#161616', 
              border: jaAdquirido ? '2px solid #39FF14' : '1px solid #222', 
              borderRadius: '12px', 
              padding: '10px 6px', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              cursor: (jaAdquirido || !souEspetador) ? 'default' : 'pointer', 
              gap: '3px',
              opacity: (!souEspetador && !jaAdquirido) ? 0.4 : 1 // Deixa os cromos em falta ligeiramente apagados para o streamer ver o que lhe falta
            }}
          >
            <img src={stk.icone} alt={stk.nome} style={{ width: '38px', height: '38px', objectFit: 'contain', filter: (!souEspetador && !jaAdquirido) ? 'grayscale(100%)' : 'none' }} />
            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#FFF', textAlign: 'center' }}>{stk.nome}</span>
            
            {jaAdquirido ? (
              <span style={{ fontSize: '9px', color: '#39FF14', fontWeight: 'bold', textShadow: '0 0 5px rgba(57,255,20,0.5)' }}>✓ OBTIDO</span>
            ) : (
              <span style={{ fontSize: '9px', color: souEspetador ? '#39FF14' : '#ff4444', fontWeight: 'bold' }}>
                {souEspetador ? `🪙 ${stk.preco}` : "FALTA 🟥"}
              </span>
            )}
          </div>
        );
      })}
    </div>
  </div>
)}

    {/* 🟢 INTERFACE EXCLUSIVA: ÁLBUM PERMANENTE DO ANFITRIÃO (MODO LEITURA SUPREMO) */}
{mostrarCadernetaDono && (
  <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, backgroundColor: '#0d0d0d', borderTop: '2px solid #FFD700', padding: '12px 16px', zIndex: 9999, borderTopLeftRadius: '20px', borderTopRightRadius: '20px', boxShadow: '0 -4px 20px rgba(0,0,0,0.9)' }}>
    
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{ fontSize: '15px' }}>📖</span>
        <span style={{ fontSize: '13px', color: '#FFD700', fontWeight: '900', letterSpacing: '0.5px' }}>O MEU ÁLBUM DE STICKERS (MODO LEITURA)</span>
      </div>
      <button onClick={() => setMostrarCadernetaDono(false)} style={{ backgroundColor: 'transparent', border: 'none', color: '#aaa', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}>✕</button>
    </div>

    <p style={{ color: '#aaa', fontSize: '10px', margin: '0 0 10px 0', fontStyle: 'italic' }}>Consulte a coleção do seu estádio. Os adeptos precisam de enviar os cromos em falta para completar a sua caderneta!</p>

        {/* GRELHA DO ÁLBUM DO STREAMER */}
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', maxHeight: '230px', overflowY: 'auto', padding: '4px 2px' }}>
      {LISTA_STICKERS.map((stk) => {
        
        // 🎯 CONVERSÃO MATEMÁTICA: Passa o ID do cromo (ex: 101) para o ID do Álbum (ex: 1)
        const idStkNum = Number(stk.id);
        const idConvertidoParaAlbum = String(idStkNum > 100 ? idStkNum - 100 : idStkNum);
        
        const cromoConcluido = idsStickersDoadosAlvo.some(id => String(id) === idConvertidoParaAlbum);

        return (
          <div
            key={stk.id}

            style={{ 
              backgroundColor: cromoConcluido ? 'rgba(255, 215, 0, 0.04)' : '#161616', 
              border: cromoConcluido ? '1.5px solid #FFD700' : '1px solid #222', 
              borderRadius: '12px', 
              padding: '10px 6px', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              gap: '3px',
              cursor: 'default',
              opacity: cromoConcluido ? 1 : 0.35
            }}
          >
            <img 
              src={stk.icone} 
              alt={stk.nome} 
              style={{ width: '38px', height: '38px', objectFit: 'contain', filter: cromoConcluido ? 'none' : 'grayscale(100%)' }} 
            />
            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#FFF', textAlign: 'center' }}>{stk.nome}</span>
            
            {cromoConcluido ? (
              <span style={{ fontSize: '9px', color: '#FFD700', fontWeight: '900', textShadow: '0 0 4px rgba(255,215,0,0.4)' }}>🏆 GANHO</span>
            ) : (
              <span style={{ fontSize: '9px', color: '#ff4444', fontWeight: 'bold' }}>FALTA 🟥</span>
            )}
          </div>
        );
      })}
    </div>
  </div>
)}

            {/* ÁREA DO CHAT DA BATALHA - ABAIXO DOS PRESENTES (BLINDADA UNIVERSAL E SEM CORTES) */}
      <div style={{ 
        // 🟢 ALTERADO DE 'relative' PARA 'fixed' PARA PRENDER NO FUNDO:
        position: 'fixed', 
        bottom: 0,
        left: 0,
        // -------------------------------------------------------------
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        gap: '10px', 
        paddingBottom: 'calc(20px + env(safe-area-inset-bottom))', // 🟢 Diminuído para colar tudo no fundo de forma segura
        paddingLeft: '15px', 
        paddingRight: '15px', 
        paddingTop: '12px', 
        background: 'linear-gradient(to top, rgba(0,0,0,0.95) 85%, rgba(0,0,0,0.4) 100%)', 
        zIndex: 1000, 
        boxSizing: 'border-box', 
        flexShrink: 0 
      }}>

        {/* PATAMAR 1 (SUPERIOR): INPUT DE TEXTO - SÓ PARA QUEM ASSISTE */}
        {souEspetador && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>

            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '100%' }}>
              <input 
                value={textoMensagem}
                onChange={(e) => setTextoMensagem(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && enviarMensagemBatalha()}
                placeholder="Diz algo ao estádio..."
                style={{ flex: 1, padding: '12px 18px', borderRadius: '25px', border: '1px solid #333', background: '#111', color: 'white', fontSize: '13px', outline: 'none' }}
              />
              <button 
                type="button"
                onClick={enviarMensagemBatalha}
                style={{ background: '#39FF14', border: 'none', width: '38px', height: '38px', borderRadius: '50%', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
              >
                ➔
              </button>
            </div>
          </div>
        )}

        {/* BOTÃO INTELIGENTE DE SAÍDA ANTECIPADA PARA ESPETADORES */}
        {souEspetador && (batalha?.fase === "ESPERA" || batalha?.fase === "FIM") && (
            <button
                type="button"
                onClick={async () => {
                  try {
                    const { doc: fDoc, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
                    await fDeleteDoc(fDoc(db, "batalhasAtivas", idBatalha, "presencas", auth.currentUser.uid)).catch(() => {});
                  } catch (e) { console.error(e); }
                  if (typeof aoSair === 'function') aoSair();
                  else window.location.href = '/?app';
                }}
                                style={{ 
                  background: 'rgba(255, 49, 49, 0.15)', 
                  color: '#FF3131', 
                  border: '1px solid #FF3131', 
                  borderRadius: '18px', 
                  padding: '0 12px', 
                  height: '38px', 
                  fontSize: '11px', 
                  fontWeight: '900', 
                  cursor: 'pointer', 
                  boxShadow: '0 0 10px rgba(255, 49, 49, 0.2)',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textTransform: 'uppercase'
                }}
              >
                Sair
              </button>
            )}
        
        {/* REORDENAÇÃO MESTRE: CONDIÇÃO REATIVA DOS BOTÕES */}
        {souEspetador ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
            {/* FILA HORIZONTAL DE 5 BOTÕES (BOTAO REDUNDANTE APAGADO PARA O ESPETADOR) */}
            {(batalha?.fase === "1ª PARTE" || batalha?.fase === "2ª PARTE") && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '6px', width: '100%', marginTop: '0px' }}>
                
                                {/* 0. BOTÃO COMPACTO DE SAÍDA (SAIR) */}
                <button
                  type="button"
                  onClick={async () => {
                    try {
                      const { doc: fDoc, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
                      await fDeleteDoc(fDoc(db, "batalhasAtivas", idBatalha, "presencas", auth.currentUser.uid)).catch(() => {});
                    } catch (e) { console.error(e); }
                    if (typeof aoSair === 'function') aoSair();
                    else window.location.href = '/?app';
                  }}
                  style={{ 
                    background: 'rgba(255, 49, 49, 0.15)', 
                    color: '#FF3131', 
                    border: '1px solid #FF3131', 
                    borderRadius: '18px', 
                    padding: '0 12px', 
                    height: '35px', 
                    fontSize: '11px', 
                    fontWeight: '900', 
                    cursor: 'pointer', 
                    boxShadow: '0 0 10px rgba(255, 49, 49, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  SAIR
                </button>

                {/* 1. BOTÃO DE PARTILHA (🔗) */}
                <button
                  type="button"
                  onClick={partilharBatalhaReal}
                  style={{ background: '#111', color: '#00F0FF', border: '1px solid #00F0FF', borderRadius: '50%', width: '35px', height: '35px', fontSize: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 10px rgba(0, 240, 255, 0.3)' }}
                  title="Partilhar com a Claque"
                >
                  🔗
                </button>

                {/* 2. BOTÃO DE TAP TAP (🔥) */}
                <button 
                  type="button"
                  onClick={processarTapTapArena}
                  style={{ background: '#000', color: '#FF007F', border: '2px solid #FF007F', borderRadius: '50%', width: '35px', height: '35px', fontSize: '15px', cursor: 'pointer', boxShadow: '0 0 10px rgba(255, 0, 127, 0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  title="Esmagar Cliques"
                >
                  🔥
                </button>

                {/* 3. BOTÃO DO TREVO DOS STICKERS (🍀) */}
                <button
                  type="button"
                  onClick={() => {
                    setMostrarMenuStickers(true);
                    setMostrarMenuLuckys(false);
                    if (typeof setMostrarPresentesPK === 'function') setMostrarPresentesPK(false);
                  }}
                  style={{ backgroundColor: 'rgba(0,0,0,0.6)', border: '2px solid #FFD700', width: '35px', height: '35px', boxSizing: 'border-box', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', cursor: 'pointer', boxShadow: '0 0 12px rgba(255,215,0,0.3)' }}
                  title="Stickers da Claque"
                >
                  🍀
                </button>

                {/* 4. BOTÃO CAIXA AMARELA (🎁) */}
                <button 
                  type="button"
                  onClick={() => {
                    if (typeof setMostrarPresentesPK === 'function') setMostrarPresentesPK(true);
                    setMostrarMenuLuckys(false);
                    setMostrarMenuStickers(false);
                  }}
                  style={{ background: 'linear-gradient(135deg, #FF8C00 0%, #FF4500 100%)', border: 'none', width: '35px', height: '35px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 0 10px rgba(255, 69, 0, 0.4)', fontSize: '15px', flexShrink: 0 }}
                  title="Presentes de Vídeo"
                >
                  🎁
                </button>

                      {/* 5. BOTÃO DO RAIO DAS LUCKYS (⚡) */}
                <button
                  type="button"
                  onClick={() => {
                    setTipoMenuAtivo("luckys");
                    setMostrarMenuLuckys(true);
                    setMostrarMenuStickers(false);
                    if (typeof setMostrarPresentesPK === 'function') setMostrarPresentesPK(false);
                  }}
                  style={{ cursor: 'pointer', fontSize: '15px', backgroundColor: 'rgba(255, 215, 0, 0.2)', width: '35px', height: '35px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #FFD700', boxShadow: '0 0 12px rgba(255, 215, 0, 0.5)', color: '#FFD700', fontWeight: '900' }}
                  title="Menu de Luckys"
                >
                  ⚡
                </button>

                {/* 🚀 6. BOLINHA ROSA DE COMBOS (💖) - CORREÇÃO DE RAJADA SUPREMA ESTILO ALII */}
                {mostrarBolinhaRosa && comboPresenteAtivo && comboDestinatarioAtivo && comboPresenteAtivo.tipoPresente !== 'sticker' && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', animation: 'bounceIn 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)' }}>
                    <button
                      type="button"
                      onClick={async (e) => {
                        e.stopPropagation();

                        // 🎯 Alinhamento Perfeito Alii: Incrementa rigorosamente pelo tamanho do bloco (ex: 188 em 188)
                        const passoComboReal = comboPresenteAtivo.quantidade || quantidadeSelecionada || 1;
                        const proximoNumeroCombo = (contagemComboCliques || 0) + passoComboReal;
                        
                        // Atualiza o contador interno da bolinha na mesma frame
                        setContagemComboCliques(proximoNumeroCombo);

                        // Sincroniza imediatamente o letreiro néon central com o mesmo valor da bolinha
                        setListaAvisosFeed(prev => prev.map(item => 
                          item.uidRemetente === auth.currentUser?.uid 
                            ? { ...item, quantidadeCombo: proximoNumeroCombo } 
                            : item
                        ));
                        
                        // Dispara a transação enviando o bloco fixo para o saldo debitar de 188 em 188 corretamente
                        await processarEnvioPresente({ 
                          ...comboPresenteAtivo, 
                          quantidade: passoComboReal,
                          tipo: comboPresenteAtivo.tipo || comboPresenteAtivo.tipoPresente || 'lucky' 
                        }, comboDestinatarioAtivo);

                        // Reinicia o relógio de 3 segundos para manter a bolinha viva
                        if (window.timerComboBancada) clearTimeout(window.timerComboBancada);
                        window.timerComboBancada = setTimeout(() => {
                          setMostrarBolinhaRosa(false);
                          setContagemComboCliques(0);
                        }, 3000);
                      }}
                      style={{ width: '35px', height: '35px', borderRadius: '50%', background: 'linear-gradient(135deg, #FF007F 0%, #FF66B2 100%)', border: '2px solid #FFF', boxShadow: '0 0 10px #FF007F, inset 0 0 4px rgba(255,255,255,0.6)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', color: '#FFF', fontWeight: '950', pointerEvents: 'auto', WebkitTapHighlightColor: 'transparent' }}
                    >
                      💖
                    </button>
                    <span style={{ color: '#FF007F', fontSize: '13px', fontWeight: '950', fontStyle: 'italic', textShadow: '1px 1px 2px #000, 0 0 4px #FFF', fontFamily: 'system-ui, sans-serif' }}>
                      x{contagemComboCliques}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (

      /* BARRA DE FERRAMENTAS UNIFICADA PARA OS STREAMERS (MIGUEL / TERESA / MÁRCIA) */
          // 🟢 RETIRADO O POSITION ABSOLUTE E ENCURTADO O PADDING PARA ENCAIXAR NO FLUXO:
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '8px', padding: '10px 15px', borderTop: '1px solid #222', width: '100%', boxSizing: 'border-box', background: 'transparent', zIndex: 1005 }}>
 
              {/* LINHA HORIZONTAL DOS BOTÕES REDONDOS COMPACTOS */}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '10px', width: '100%', marginBottom: '-50px', marginRight: '115px', zIndex: 1010, position: 'relative' }}>

              {/* 1. BOTÃO INICIAR: SÓ APARECE NA FASE DE ESPERA */}
              {batalha?.fase === "ESPERA" && (
                <button 
                  type="button"
                  onClick={() => updateDoc(doc(db, "batalhasAtivas", idBatalha), { [souOJogadorA ? "prontoA" : "prontoB"]: true })} 
                  style={{ 
                    background: (souOJogadorA ? batalha.prontoA : batalha.prontoB) ? '#444' : '#39FF14', 
                    color: (souOJogadorA ? batalha.prontoA : batalha.prontoB) ? 'white' : 'black', 
                    border: 'none', borderRadius: '25px', padding: '0 12px', height: '35px', 
                    fontWeight: '900', fontSize: '11px', cursor: 'pointer', letterSpacing: '0.5px',
                    boxShadow: (souOJogadorA ? batalha.prontoA : batalha.prontoB) ? 'none' : '0 0 10px rgba(57, 255, 20, 0.4)',
                    whiteSpace: 'nowrap'
                  }}
                >
                  { (souOJogadorA ? batalha.prontoA : batalha.prontoB) ? "AGUARDANDO..." : "INICIAR PK" }
                </button>
              )}

              {/* 2. BOTÃO CANCELAR / SAIR: SÓ APARECE NA FASE DE ESPERA */}
              {batalha?.fase === "ESPERA" && (
                <button 
                  type="button"
                  onClick={async () => {
                    if (window.confirm("Queres mesmo cancelar o desafio e sair da Arena? ⚽🟥")) {
                      try {
                        const { doc: fDoc, updateDoc: fUpdateDoc, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
                        await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), { convitePK: null });
                        if (batalha?.idB) await fUpdateDoc(fDoc(db, "utilizadores", batalha.idB), { convitePK: null }).catch(() => {});
                        if (batalha?.idA) await fUpdateDoc(fDoc(db, "utilizadores", batalha.idA), { convitePK: null }).catch(() => {});
                        await fDeleteDoc(fDoc(db, "batalhasAtivas", idBatalha)).catch(() => {});
                        if (typeof aoSair === 'function') aoSair();
                      } catch (errCancel) {
                        console.error("Erro ao cancelar batalha:", errCancel);
                      }
                    }
                  }}
                  style={{ 
                    background: 'rgba(255, 68, 68, 0.15)', color: '#ff4444', 
                    border: '1px solid #ff4444', borderRadius: '50%', width: '35px', height: '35px', 
                    fontSize: '15px', fontWeight: '900', cursor: 'pointer', display: 'flex', 
                    alignItems: 'center', justifyContent: 'center' 
                  }}
                  title="Sair / Cancelar Desafio"
                >
                  ✕
                </button>
              )}

                          {/* 🎁 BOTÃO DE CONSULTA DA CADERNETA (APENAS PARA OS STREAMERS EM DIRETO - CORRIGIDO) */}
              {(souOJogadorA || batalha?.idB === auth.currentUser?.uid) && (
                <button
                  type="button"
                  onClick={() => {
                    // CORRIGIDO: Ativa o estado certo do anfitrião para carregar o álbum em modo leitura
                    setMostrarCadernetaDono(true);
                    setMostrarMenuStickers(false);
                  }}
                  style={{
                    background: '#111',
                    color: '#FFD700',
                    border: '1px solid #FFD700',
                    borderRadius: '50%',
                    width: '35px',
                    height: '35px',
                    fontSize: '15px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 0 10px rgba(255, 215, 0, 0.2)'
                  }}
                  title="Consultar a minha Caderneta em Direto"
                >
                  📖
                </button>
              )}

              {/* 3. BOTÃO DE PARTILHA COM TORPEDO EM MASSA (DISPONÍVEL SEMPRE) */}
              <button
                type="button"
                onClick={partilharBatalhaReal}
                style={{
                  background: '#111',
                  color: '#39FF14',
                  border: '1px solid #39FF14',
                  borderRadius: '50%',
                  width: '35px',
                  height: '35px',
                  fontSize: '15px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 0 10px rgba(57, 255, 20, 0.2)'
                }}
                title="Partilhar com a Claque"
              >
                🔗
              </button>

              {/* 4. BOTÃO DO MICROFONE INTERATIVO (DISPONÍVEL SEMPRE) */}
              <button
                type="button"
                onClick={alternarMicrofoneBatalha}
                style={{
                  background: microLigado ? '#39FF14' : '#222',
                  color: microLigado ? 'black' : 'white',
                  border: microLigado ? 'none' : '1px solid #ff4444',
                  borderRadius: '50%',
                  width: '35px',
                  height: '35px',
                  fontSize: '15px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: microLigado ? '0 0 10px #39FF14' : 'none'
                }}
              >
                {microLigado ? "🎙️" : "🔇"}
              </button>
            </div>
          </div>
        )}

        {/* 🏆 BOTÃO SUPREMO DE RESET E LIMPEZA DE EXPEDIENTE - CRAVADO NO FUNDO DO RELVADO */}
        {!souEspetador && (
          // 🟢 RETIRADO O POSITION ABSOLUTE E O LEFT PARA AJUSTAR NO FLUXO CENTRALIZADO:
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', zIndex: 1006, pointerEvents: 'auto', marginTop: '4px' }}>
            <button
              type="button"
              onClick={async () => {
                const partidaACorrer = batalha?.fase === "1ª PARTE"
                  || batalha?.fase === "INTERVALO"
                  || batalha?.fase === "2ª PARTE";
                const pergunta = partidaACorrer
                  ? "A partida está a decorrer. Se saíres agora abandonas o jogo. Queres mesmo sair? 🟥"
                  : "Queres encerrar as batalhas de hoje? 🟥";
                if (window.confirm(pergunta)) {
                  try {
                    const { doc: fDoc, updateDoc: fUpdateDoc, collection: fColl, getDocs: fGetDocs, deleteDoc: fDeleteDoc, query: fQuery } = await import('firebase/firestore');
                    
                    // 1. Liberta o perfil do streamer no Firebase
                    await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), {
                      convitePK: null,
                      emLive: false
                    }).catch(() => {});

                    // 1b. FECHAR A PARTIDA PARA TODA A GENTE.
                    const souLutador = auth.currentUser.uid === batalha?.idA
                      || auth.currentUser.uid === batalha?.idB;
                    if (souLutador) {
                      await fUpdateDoc(doc(db, "batalhasAtivas", idBatalha), {
                        fase: "FIM",
                        tempo: 0,
                        abandonadaPor: auth.currentUser.uid,
                      }).catch(() => {});

                      // O convite dos DOIS lutadores, não só o meu.
                      for (const uidLutador of [batalha?.idA, batalha?.idB]) {
                        if (!uidLutador) continue;
                        await fUpdateDoc(fDoc(db, "utilizadores", uidLutador), {
                          convitePK: null,
                        }).catch(() => {});
                      }
                    }

                    // 2. Limpa o chat de texto acumulado nesta sessão
                    try {
                      const chatSnap = await fGetDocs(fQuery(fColl(db, "chatsArena", auth.currentUser.uid, "chat")));
                      const chatDeletes = chatSnap.docs.map(d => fDeleteDoc(d.ref));
                      await Promise.all(chatDeletes);
                    } catch (chatErr) { console.log("Chat já limpo:", chatErr); }

                    // 3. Limpa os espectadores fantasma da subcoleção de presenças
                    try {
                      const presSnap = await fGetDocs(fQuery(fColl(db, "batalhasAtivas", idBatalha, "presencas")));
                      const presDeletes = presSnap.docs.map(d => fDeleteDoc(d.ref));
                      await Promise.all(presDeletes);
                    } catch (presErr) { console.log("Presenças já limpas:", presErr); }

                    // 4. Fecha a sessão de vídeo: despublica, apaga as câmaras,
                    //    remove os handlers, sai do canal e larga o cliente.
                    await ligacao.terminar();

                  } catch (errSupreme) {
                    console.error("Erro no Reset Supremo:", errSupreme);
                  }

                  // 5. Chuta o streamer com total segurança para fora do ecrã do jogo
                  if (typeof aoSair === 'function') aoSair();
                  else window.location.href = '/?app';
                }
              }}
                style={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255, 49, 49, 0.15)', 
                color: '#FF3131', 
                border: '1px solid #FF3131', 
                borderRadius: '18px', 
                padding: '0 12px', 
                height: '35px', 
                fontSize: '11px', 
                fontWeight: '900', 
                cursor: 'pointer', 
                boxShadow: '0 0 10px rgba(255, 49, 49, 0.2)',
                whiteSpace: 'nowrap',
                // 🟢 ALINHAMENTO FIXO VERTICAL À DIREITA DA MESMA FILA:
                position: 'absolute',
                top: '22px',
                right: '15px',
                zIndex: 1015
              }}  
            >
              {(batalha?.fase === "1ª PARTE" || batalha?.fase === "INTERVALO" || batalha?.fase === "2ª PARTE")
                ? "ABANDONAR"
                : "FECHAR"}
            </button>
          </div>
        )}
      </div>

            {/* CORTINA DE DESAFIO RÁPIDO (PROCURAR NOVO RIVAL SEM SAIR) */}
      {mostrarBuscaRivalRapida && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.96)', zIndex: 100005, display: 'flex', flexDirection: 'column', padding: '40px 20px', backdropFilter: 'blur(12px)' }}>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', borderBottom: '1px solid #333', paddingBottom: '10px' }}>
            <h2 style={{ color: '#39FF14', margin: 0, fontSize: '18px', fontWeight: '900' }}>NOVO ADVERSÁRIO 🔄</h2>
            <button onClick={() => setMostrarBuscaRivalRapida(false)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', fontWeight: 'bold', cursor: 'pointer' }}>✕</button>
          </div>

          {/* BARRA DE PESQUISA RÁPIDA CORRIGIDA */}
          <div style={{ marginBottom: '15px' }}>
            <input 
              type="text"
              placeholder="Procurar craque pelo nome..."
              onChange={(e) => {
                const termo = e.target.value.toLowerCase().trim();
                // Filtra de forma isolada para não estragar a lista base do Firebase
                setPesquisaArena(termo); 
              }}
              style={{ width: '100%', backgroundColor: '#111', border: '1px solid #333', color: 'white', padding: '10px 15px', borderRadius: '50px', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ flex: 1, overflowY: 'auto' }}>
            {/* Lógica de renderização filtrada sem quebra de dados */}
            {(() => {
              const utilizadoresFiltradosRapidos = (listaEspectadores || []).filter(u => {
                if (!pesquisaArena) return true;
                return u.nome?.toLowerCase().includes(pesquisaArena);
              });

              if (utilizadoresFiltradosRapidos.length === 0) {
                return <p style={{ color: '#666', textAlign: 'center', fontSize: '13px', marginTop: '20px' }}>Nenhum jogador livre encontrado de momento... 🏟️</p>;
              }

              return utilizadoresFiltradosRapidos.map((user) => {
                if (user.uid === auth.currentUser?.uid) return null;

                return (
                  <div 
                    key={user.uid}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px', marginBottom: '8px', backgroundColor: '#161616', borderRadius: '12px', border: '1px solid #222' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <img src={user.foto || 'https://placeholder.com'} alt="Perfil" style={{ width: '38px', height: '38px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover' }} />
                      <span style={{ color: 'white', fontWeight: 'bold', fontSize: '13px' }}>{user.nome}</span>
                    </div>

                    <button
                      onClick={async () => {
                        if (window.confirm(`Queres lançar um desafio PK rápido a @${user.nome}? ⚽🔥`)) {
                          try {
                            const { doc: fDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
                            
                            // REMOVIDO O STOP: Mantém a câmara fluida na transição sem crashar o hardware do AgoraRTC
                            
                            // Atualiza o novo rival na base de dados de forma síncrona
                            await fUpdateDoc(fDoc(db, "utilizadores", user.uid), {
                              convitePK: {
                                de: auth.currentUser.uid,
                                nome: auth.currentUser.displayName || "Desafiador",
                                fotoUrl: auth.currentUser.photoURL || "",
                                status: "pendente", // Alinhado com o status correto da ArenaPK
                                idBatalha: idBatalha
                              }
                            });

                            await fUpdateDoc(fDoc(db, "batalhasAtivas", idBatalha), {
                              fase: "ESPERA",
                              prontoA: false,
                              prontoB: false,
                              pontosA: 0,
                              pontosB: 0,
                              golosA: 0,
                              golosB: 0,
                              ultimoVideo: null,
                              idB: user.uid
                            });

                            setMostrarBuscaRivalRapida(false);
                            alert("Desafio PK enviado! A aguardar que o novo rival entre em campo... ⏳");
                          } catch (errFast) {
                            console.error("Erro no desafio rápido:", errFast);
                          }
                        }
                      }}
                      style={{ backgroundColor: '#39FF14', color: 'black', border: 'none', padding: '6px 14px', borderRadius: '20px', fontSize: '11px', fontWeight: '900', cursor: 'pointer', boxShadow: '0 0 8px rgba(57, 255, 20, 0.3)' }}
                    >
                      CONVIDAR
                    </button>
                  </div>
                );
              });
            })()}
          </div>
        </div>
      )}

            {/* CORTINA DE UTILIZADORES DA ARENA (A CLAQUE REAL) */}
      {mostrarListaEspectadores && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.95)', zIndex: 100000, display: 'flex', flexDirection: 'column', padding: '40px 20px', backdropFilter: 'blur(10px)' }}>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', borderBottom: '1px solid #333', paddingBottom: '10px' }}>
            <h2 style={{ color: '#39FF14', margin: 0, fontSize: '18px', fontWeight: '900' }}>ESTÁDIO - ADEPTOS 👁️</h2>
            <button onClick={() => setMostrarListaEspectadores(false)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', fontWeight: 'bold', cursor: 'pointer' }}>✕</button>
          </div>

          <div style={{ flex: 1, overflowY: 'auto' }}>
            {listaEspectadores.length === 0 ? (
              <p style={{ color: '#666', textAlign: 'center', fontSize: '14px', marginTop: '20px' }}>Ainda não há adeptos na bancada... 🏟️</p>
            ) : (
              listaEspectadores.map((user) => {
                const souEuProprio = user.uid === auth.currentUser?.uid;
                const euSouStreamer = batalha && (auth.currentUser?.uid === batalha.idA || auth.currentUser?.uid === batalha.idB);

                return (
                  <div 
                    key={user.uid}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px', marginBottom: '10px', backgroundColor: '#1a1a1a', borderRadius: '12px', border: '1px solid #222' }}
                  >
                                        <div 
                      onClick={() => {
                        window.dispatchEvent(new CustomEvent('abrirPerfilUsuario', { detail: user.uid }));
                      }}
                      style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}
                    >
                      <img src={user.foto || 'https://placeholder.com'} alt="Perfil" style={{ width: '40px', height: '40px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover' }} />
                      <span style={{ color: 'white', fontWeight: 'bold', fontSize: '14px' }}>{user.nome}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {!souEuProprio && (
                                                window.seguidosLocais?.includes(user.uid) ? (
                          <span style={{ color: '#39FF14', fontSize: '11px', fontWeight: 'bold', padding: '6px 12px' }}>
                            ✅ SEGUIDO
                          </span>
                        ) : (
                          <button
                            onClick={async (e) => {
                              e.stopPropagation();
                              try {
                                const { doc: fDoc, setDoc: fSetDoc, serverTimestamp: fTime } = await import('firebase/firestore');
                                
                                // 1. Regista na TUA lista que estás a SEGUIR este craque
                                await setDoc(fDoc(db, "utilizadores", auth.currentUser.uid, "seguindo", user.uid), {
                                  nome: user.nome,
                                  data: fTime()
                                });

                                // 2. Regista na lista DELES que eles ganharam um SEGUIDOR (tu)
                                await setDoc(fDoc(db, "utilizadores", user.uid, "seguidores", auth.currentUser.uid), {
                                  nome: auth.currentUser.displayName || "Craque",
                                  data: fTime()
                                });

                                // 3. Guarda na memória para o botão sumir imediatamente na tela
                                if (!window.seguidosLocais) window.seguidosLocais = [];
                                window.seguidosLocais.push(user.uid);

                                alert(`Estás a seguir @${user.nome}! ⚽🔥`);
                                // Dá um toque visual para redesenhar o Olhinho com o visto verde
                                setTotalGente(prev => prev);
                              } catch (errSeg) {
                                console.error("Erro ao seguir utilizador:", errSeg);
                              }
                                    }}
        style={{ backgroundColor: 'rgba(255, 0, 127, 0.1)', color: '#FF007F' }}
      >
        {window.seguidosLocais?.includes(user.uid) ? "SEGUIDO ✓" : "+ SEGUIR"}
      </button>
                     )
                      )}

                      {/* BOTÃO EXPULSAR: SÓ APARECE SE QUEM ESTIVER A LER FOR O STREAMER DA BANCADA DO ADEPTO */}
                      {(() => {
                        const euSouOStreamerA_DesteJogo = auth.currentUser?.uid === (batalha?.idA || idA);
                        const euSouOStreamerB_DesteJogo = auth.currentUser?.uid === batalha?.idB;
                        const souEuProprio = user.uid === auth.currentUser?.uid;

    const idCriador = batalha?.idA || idA;
const idRival = batalha?.idB;
const userEhJogador = user.uid === idCriador || user.uid === idRival;

const podeExpulsar = !userEhJogador && ((euSouOStreamerA_DesteJogo && user.bancada === 'A') || (euSouOStreamerB_DesteJogo && user.bancada === 'B'));

                        if (podeExpulsar && !souEuProprio) {
                          return (
                            <button
                              onClick={async (e) => {
                                e.stopPropagation();
                                if (window.confirm(`Tens a certeza que queres expulsar @${user.nome} do estádio? 🟥`)) {
                                  try {
                                    const { doc: fDoc, setDoc: fSetDoc, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
                                    
                                    // 1. Regista o banimento permanente na coleção deste jogo
                                    await fSetDoc(fDoc(db, "batalhasAtivas", idBatalha, "expulsos", user.uid), {
                                      uid: user.uid,
                                      nome: user.nome,
                                      expulsoPor: auth.currentUser.uid,
                                      data: Date.now()
                                    });

                                    // 2. Remove fisicamente das presenças para acionar o gatilho visual no telemóvel dele
                                    await fDeleteDoc(fDoc(db, "batalhasAtivas", idBatalha, "presencas", user.uid));
                                    
                                    alert(`Utilizador @${user.nome} expulso com sucesso!`);
                                  } catch (errKick) { console.error("Erro ao expulsar:", errKick); }
                                }
                              }}
                              style={{ backgroundColor: '#ff4444', color: 'black', border: 'none', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 0 8px rgba(255, 68, 68, 0.4)', marginLeft: '6px' }}
                            >
                              EXPULSAR 🟥
                            </button>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default JogoPK;